package dev.helpmycity.`data`.local.database

import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.EntityUpsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.coroutines.createFlow
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import kotlin.ByteArray
import kotlin.Double
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class IssueDao_Impl(
  __db: RoomDatabase,
) : IssueDao {
  private val __db: RoomDatabase

  private val __insertAdapterOfIssueSupportEntity: EntityInsertAdapter<IssueSupportEntity>

  private val __upsertAdapterOfIssueEntity: EntityUpsertAdapter<IssueEntity>

  private val __upsertAdapterOfIssuePhotoEntity: EntityUpsertAdapter<IssuePhotoEntity>

  private val __upsertAdapterOfIssueStatusChangeEntity: EntityUpsertAdapter<IssueStatusChangeEntity>

  private val __upsertAdapterOfIssueSupportEntity: EntityUpsertAdapter<IssueSupportEntity>
  init {
    this.__db = __db
    this.__insertAdapterOfIssueSupportEntity = object : EntityInsertAdapter<IssueSupportEntity>() {
      protected override fun createQuery(): String = "INSERT OR IGNORE INTO `issue_supports` (`issue_id`,`user_id`,`created_at`,`sync_state`) VALUES (?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: IssueSupportEntity) {
        statement.bindText(1, entity.issueId)
        statement.bindText(2, entity.userId)
        statement.bindLong(3, entity.createdAtMillis)
        statement.bindText(4, entity.syncState)
      }
    }
    this.__upsertAdapterOfIssueEntity = EntityUpsertAdapter<IssueEntity>(object : EntityInsertAdapter<IssueEntity>() {
      protected override fun createQuery(): String = "INSERT INTO `issues` (`id`,`title`,`description`,`requested_action`,`category`,`status`,`priority`,`location_description`,`latitude`,`longitude`,`geocoded_address`,`neighborhood`,`council_district`,`census_tract`,`police_precinct`,`department_id`,`reporter_name`,`reporter_email`,`reporter_phone`,`submitted_by_user_id`,`notes_source`,`review_state`,`reviewed_by_user_id`,`reviewed_by_display_name`,`reviewed_at`,`rejection_reason`,`edited_by_user_id`,`edited_by_display_name`,`edited_at`,`edit_revision`,`edited_fields`,`resolution`,`external_system`,`external_reference_number`,`external_submitted_at`,`external_last_checked_at`,`external_reported_status`,`support_count`,`created_at`,`updated_at`,`sync_state`,`last_synced_at`,`remote_version`) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: IssueEntity) {
        statement.bindText(1, entity.id)
        statement.bindText(2, entity.title)
        statement.bindText(3, entity.description)
        statement.bindText(4, entity.requestedAction)
        statement.bindText(5, entity.category)
        statement.bindText(6, entity.status)
        statement.bindText(7, entity.priority)
        statement.bindText(8, entity.locationDescription)
        val _tmpLatitude: Double? = entity.latitude
        if (_tmpLatitude == null) {
          statement.bindNull(9)
        } else {
          statement.bindDouble(9, _tmpLatitude)
        }
        val _tmpLongitude: Double? = entity.longitude
        if (_tmpLongitude == null) {
          statement.bindNull(10)
        } else {
          statement.bindDouble(10, _tmpLongitude)
        }
        val _tmpGeocodedAddress: String? = entity.geocodedAddress
        if (_tmpGeocodedAddress == null) {
          statement.bindNull(11)
        } else {
          statement.bindText(11, _tmpGeocodedAddress)
        }
        val _tmpNeighborhood: String? = entity.neighborhood
        if (_tmpNeighborhood == null) {
          statement.bindNull(12)
        } else {
          statement.bindText(12, _tmpNeighborhood)
        }
        val _tmpCouncilDistrict: String? = entity.councilDistrict
        if (_tmpCouncilDistrict == null) {
          statement.bindNull(13)
        } else {
          statement.bindText(13, _tmpCouncilDistrict)
        }
        val _tmpCensusTract: String? = entity.censusTract
        if (_tmpCensusTract == null) {
          statement.bindNull(14)
        } else {
          statement.bindText(14, _tmpCensusTract)
        }
        val _tmpPolicePrecinct: String? = entity.policePrecinct
        if (_tmpPolicePrecinct == null) {
          statement.bindNull(15)
        } else {
          statement.bindText(15, _tmpPolicePrecinct)
        }
        val _tmpDepartmentId: String? = entity.departmentId
        if (_tmpDepartmentId == null) {
          statement.bindNull(16)
        } else {
          statement.bindText(16, _tmpDepartmentId)
        }
        val _tmpReporterName: String? = entity.reporterName
        if (_tmpReporterName == null) {
          statement.bindNull(17)
        } else {
          statement.bindText(17, _tmpReporterName)
        }
        val _tmpReporterEmail: String? = entity.reporterEmail
        if (_tmpReporterEmail == null) {
          statement.bindNull(18)
        } else {
          statement.bindText(18, _tmpReporterEmail)
        }
        val _tmpReporterPhone: String? = entity.reporterPhone
        if (_tmpReporterPhone == null) {
          statement.bindNull(19)
        } else {
          statement.bindText(19, _tmpReporterPhone)
        }
        val _tmpSubmittedByUserId: String? = entity.submittedByUserId
        if (_tmpSubmittedByUserId == null) {
          statement.bindNull(20)
        } else {
          statement.bindText(20, _tmpSubmittedByUserId)
        }
        statement.bindText(21, entity.notesSource)
        statement.bindText(22, entity.reviewState)
        val _tmpReviewedByUserId: String? = entity.reviewedByUserId
        if (_tmpReviewedByUserId == null) {
          statement.bindNull(23)
        } else {
          statement.bindText(23, _tmpReviewedByUserId)
        }
        val _tmpReviewedByDisplayName: String? = entity.reviewedByDisplayName
        if (_tmpReviewedByDisplayName == null) {
          statement.bindNull(24)
        } else {
          statement.bindText(24, _tmpReviewedByDisplayName)
        }
        val _tmpReviewedAtMillis: Long? = entity.reviewedAtMillis
        if (_tmpReviewedAtMillis == null) {
          statement.bindNull(25)
        } else {
          statement.bindLong(25, _tmpReviewedAtMillis)
        }
        val _tmpRejectionReason: String? = entity.rejectionReason
        if (_tmpRejectionReason == null) {
          statement.bindNull(26)
        } else {
          statement.bindText(26, _tmpRejectionReason)
        }
        val _tmpEditedByUserId: String? = entity.editedByUserId
        if (_tmpEditedByUserId == null) {
          statement.bindNull(27)
        } else {
          statement.bindText(27, _tmpEditedByUserId)
        }
        val _tmpEditedByDisplayName: String? = entity.editedByDisplayName
        if (_tmpEditedByDisplayName == null) {
          statement.bindNull(28)
        } else {
          statement.bindText(28, _tmpEditedByDisplayName)
        }
        val _tmpEditedAtMillis: Long? = entity.editedAtMillis
        if (_tmpEditedAtMillis == null) {
          statement.bindNull(29)
        } else {
          statement.bindLong(29, _tmpEditedAtMillis)
        }
        val _tmpEditRevision: Int? = entity.editRevision
        if (_tmpEditRevision == null) {
          statement.bindNull(30)
        } else {
          statement.bindLong(30, _tmpEditRevision.toLong())
        }
        val _tmpEditedFields: String? = entity.editedFields
        if (_tmpEditedFields == null) {
          statement.bindNull(31)
        } else {
          statement.bindText(31, _tmpEditedFields)
        }
        val _tmpResolution: String? = entity.resolution
        if (_tmpResolution == null) {
          statement.bindNull(32)
        } else {
          statement.bindText(32, _tmpResolution)
        }
        val _tmpExternalSystem: String? = entity.externalSystem
        if (_tmpExternalSystem == null) {
          statement.bindNull(33)
        } else {
          statement.bindText(33, _tmpExternalSystem)
        }
        val _tmpExternalReferenceNumber: String? = entity.externalReferenceNumber
        if (_tmpExternalReferenceNumber == null) {
          statement.bindNull(34)
        } else {
          statement.bindText(34, _tmpExternalReferenceNumber)
        }
        val _tmpExternalSubmittedAtMillis: Long? = entity.externalSubmittedAtMillis
        if (_tmpExternalSubmittedAtMillis == null) {
          statement.bindNull(35)
        } else {
          statement.bindLong(35, _tmpExternalSubmittedAtMillis)
        }
        val _tmpExternalLastCheckedAtMillis: Long? = entity.externalLastCheckedAtMillis
        if (_tmpExternalLastCheckedAtMillis == null) {
          statement.bindNull(36)
        } else {
          statement.bindLong(36, _tmpExternalLastCheckedAtMillis)
        }
        val _tmpExternalReportedStatus: String? = entity.externalReportedStatus
        if (_tmpExternalReportedStatus == null) {
          statement.bindNull(37)
        } else {
          statement.bindText(37, _tmpExternalReportedStatus)
        }
        statement.bindLong(38, entity.supportCount.toLong())
        statement.bindLong(39, entity.createdAtMillis)
        statement.bindLong(40, entity.updatedAtMillis)
        statement.bindText(41, entity.syncState)
        val _tmpLastSyncedAtMillis: Long? = entity.lastSyncedAtMillis
        if (_tmpLastSyncedAtMillis == null) {
          statement.bindNull(42)
        } else {
          statement.bindLong(42, _tmpLastSyncedAtMillis)
        }
        val _tmpRemoteVersion: String? = entity.remoteVersion
        if (_tmpRemoteVersion == null) {
          statement.bindNull(43)
        } else {
          statement.bindText(43, _tmpRemoteVersion)
        }
      }
    }, object : EntityDeleteOrUpdateAdapter<IssueEntity>() {
      protected override fun createQuery(): String = "UPDATE `issues` SET `id` = ?,`title` = ?,`description` = ?,`requested_action` = ?,`category` = ?,`status` = ?,`priority` = ?,`location_description` = ?,`latitude` = ?,`longitude` = ?,`geocoded_address` = ?,`neighborhood` = ?,`council_district` = ?,`census_tract` = ?,`police_precinct` = ?,`department_id` = ?,`reporter_name` = ?,`reporter_email` = ?,`reporter_phone` = ?,`submitted_by_user_id` = ?,`notes_source` = ?,`review_state` = ?,`reviewed_by_user_id` = ?,`reviewed_by_display_name` = ?,`reviewed_at` = ?,`rejection_reason` = ?,`edited_by_user_id` = ?,`edited_by_display_name` = ?,`edited_at` = ?,`edit_revision` = ?,`edited_fields` = ?,`resolution` = ?,`external_system` = ?,`external_reference_number` = ?,`external_submitted_at` = ?,`external_last_checked_at` = ?,`external_reported_status` = ?,`support_count` = ?,`created_at` = ?,`updated_at` = ?,`sync_state` = ?,`last_synced_at` = ?,`remote_version` = ? WHERE `id` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: IssueEntity) {
        statement.bindText(1, entity.id)
        statement.bindText(2, entity.title)
        statement.bindText(3, entity.description)
        statement.bindText(4, entity.requestedAction)
        statement.bindText(5, entity.category)
        statement.bindText(6, entity.status)
        statement.bindText(7, entity.priority)
        statement.bindText(8, entity.locationDescription)
        val _tmpLatitude: Double? = entity.latitude
        if (_tmpLatitude == null) {
          statement.bindNull(9)
        } else {
          statement.bindDouble(9, _tmpLatitude)
        }
        val _tmpLongitude: Double? = entity.longitude
        if (_tmpLongitude == null) {
          statement.bindNull(10)
        } else {
          statement.bindDouble(10, _tmpLongitude)
        }
        val _tmpGeocodedAddress: String? = entity.geocodedAddress
        if (_tmpGeocodedAddress == null) {
          statement.bindNull(11)
        } else {
          statement.bindText(11, _tmpGeocodedAddress)
        }
        val _tmpNeighborhood: String? = entity.neighborhood
        if (_tmpNeighborhood == null) {
          statement.bindNull(12)
        } else {
          statement.bindText(12, _tmpNeighborhood)
        }
        val _tmpCouncilDistrict: String? = entity.councilDistrict
        if (_tmpCouncilDistrict == null) {
          statement.bindNull(13)
        } else {
          statement.bindText(13, _tmpCouncilDistrict)
        }
        val _tmpCensusTract: String? = entity.censusTract
        if (_tmpCensusTract == null) {
          statement.bindNull(14)
        } else {
          statement.bindText(14, _tmpCensusTract)
        }
        val _tmpPolicePrecinct: String? = entity.policePrecinct
        if (_tmpPolicePrecinct == null) {
          statement.bindNull(15)
        } else {
          statement.bindText(15, _tmpPolicePrecinct)
        }
        val _tmpDepartmentId: String? = entity.departmentId
        if (_tmpDepartmentId == null) {
          statement.bindNull(16)
        } else {
          statement.bindText(16, _tmpDepartmentId)
        }
        val _tmpReporterName: String? = entity.reporterName
        if (_tmpReporterName == null) {
          statement.bindNull(17)
        } else {
          statement.bindText(17, _tmpReporterName)
        }
        val _tmpReporterEmail: String? = entity.reporterEmail
        if (_tmpReporterEmail == null) {
          statement.bindNull(18)
        } else {
          statement.bindText(18, _tmpReporterEmail)
        }
        val _tmpReporterPhone: String? = entity.reporterPhone
        if (_tmpReporterPhone == null) {
          statement.bindNull(19)
        } else {
          statement.bindText(19, _tmpReporterPhone)
        }
        val _tmpSubmittedByUserId: String? = entity.submittedByUserId
        if (_tmpSubmittedByUserId == null) {
          statement.bindNull(20)
        } else {
          statement.bindText(20, _tmpSubmittedByUserId)
        }
        statement.bindText(21, entity.notesSource)
        statement.bindText(22, entity.reviewState)
        val _tmpReviewedByUserId: String? = entity.reviewedByUserId
        if (_tmpReviewedByUserId == null) {
          statement.bindNull(23)
        } else {
          statement.bindText(23, _tmpReviewedByUserId)
        }
        val _tmpReviewedByDisplayName: String? = entity.reviewedByDisplayName
        if (_tmpReviewedByDisplayName == null) {
          statement.bindNull(24)
        } else {
          statement.bindText(24, _tmpReviewedByDisplayName)
        }
        val _tmpReviewedAtMillis: Long? = entity.reviewedAtMillis
        if (_tmpReviewedAtMillis == null) {
          statement.bindNull(25)
        } else {
          statement.bindLong(25, _tmpReviewedAtMillis)
        }
        val _tmpRejectionReason: String? = entity.rejectionReason
        if (_tmpRejectionReason == null) {
          statement.bindNull(26)
        } else {
          statement.bindText(26, _tmpRejectionReason)
        }
        val _tmpEditedByUserId: String? = entity.editedByUserId
        if (_tmpEditedByUserId == null) {
          statement.bindNull(27)
        } else {
          statement.bindText(27, _tmpEditedByUserId)
        }
        val _tmpEditedByDisplayName: String? = entity.editedByDisplayName
        if (_tmpEditedByDisplayName == null) {
          statement.bindNull(28)
        } else {
          statement.bindText(28, _tmpEditedByDisplayName)
        }
        val _tmpEditedAtMillis: Long? = entity.editedAtMillis
        if (_tmpEditedAtMillis == null) {
          statement.bindNull(29)
        } else {
          statement.bindLong(29, _tmpEditedAtMillis)
        }
        val _tmpEditRevision: Int? = entity.editRevision
        if (_tmpEditRevision == null) {
          statement.bindNull(30)
        } else {
          statement.bindLong(30, _tmpEditRevision.toLong())
        }
        val _tmpEditedFields: String? = entity.editedFields
        if (_tmpEditedFields == null) {
          statement.bindNull(31)
        } else {
          statement.bindText(31, _tmpEditedFields)
        }
        val _tmpResolution: String? = entity.resolution
        if (_tmpResolution == null) {
          statement.bindNull(32)
        } else {
          statement.bindText(32, _tmpResolution)
        }
        val _tmpExternalSystem: String? = entity.externalSystem
        if (_tmpExternalSystem == null) {
          statement.bindNull(33)
        } else {
          statement.bindText(33, _tmpExternalSystem)
        }
        val _tmpExternalReferenceNumber: String? = entity.externalReferenceNumber
        if (_tmpExternalReferenceNumber == null) {
          statement.bindNull(34)
        } else {
          statement.bindText(34, _tmpExternalReferenceNumber)
        }
        val _tmpExternalSubmittedAtMillis: Long? = entity.externalSubmittedAtMillis
        if (_tmpExternalSubmittedAtMillis == null) {
          statement.bindNull(35)
        } else {
          statement.bindLong(35, _tmpExternalSubmittedAtMillis)
        }
        val _tmpExternalLastCheckedAtMillis: Long? = entity.externalLastCheckedAtMillis
        if (_tmpExternalLastCheckedAtMillis == null) {
          statement.bindNull(36)
        } else {
          statement.bindLong(36, _tmpExternalLastCheckedAtMillis)
        }
        val _tmpExternalReportedStatus: String? = entity.externalReportedStatus
        if (_tmpExternalReportedStatus == null) {
          statement.bindNull(37)
        } else {
          statement.bindText(37, _tmpExternalReportedStatus)
        }
        statement.bindLong(38, entity.supportCount.toLong())
        statement.bindLong(39, entity.createdAtMillis)
        statement.bindLong(40, entity.updatedAtMillis)
        statement.bindText(41, entity.syncState)
        val _tmpLastSyncedAtMillis: Long? = entity.lastSyncedAtMillis
        if (_tmpLastSyncedAtMillis == null) {
          statement.bindNull(42)
        } else {
          statement.bindLong(42, _tmpLastSyncedAtMillis)
        }
        val _tmpRemoteVersion: String? = entity.remoteVersion
        if (_tmpRemoteVersion == null) {
          statement.bindNull(43)
        } else {
          statement.bindText(43, _tmpRemoteVersion)
        }
        statement.bindText(44, entity.id)
      }
    })
    this.__upsertAdapterOfIssuePhotoEntity = EntityUpsertAdapter<IssuePhotoEntity>(object : EntityInsertAdapter<IssuePhotoEntity>() {
      protected override fun createQuery(): String = "INSERT INTO `issue_photos` (`id`,`issue_id`,`bytes`,`remote_url`,`caption`,`created_at`,`sync_state`,`last_synced_at`,`remote_version`) VALUES (?,?,?,?,?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: IssuePhotoEntity) {
        statement.bindText(1, entity.id)
        statement.bindText(2, entity.issueId)
        val _tmpBytes: ByteArray? = entity.bytes
        if (_tmpBytes == null) {
          statement.bindNull(3)
        } else {
          statement.bindBlob(3, _tmpBytes)
        }
        val _tmpRemoteUrl: String? = entity.remoteUrl
        if (_tmpRemoteUrl == null) {
          statement.bindNull(4)
        } else {
          statement.bindText(4, _tmpRemoteUrl)
        }
        val _tmpCaption: String? = entity.caption
        if (_tmpCaption == null) {
          statement.bindNull(5)
        } else {
          statement.bindText(5, _tmpCaption)
        }
        statement.bindLong(6, entity.createdAtMillis)
        statement.bindText(7, entity.syncState)
        val _tmpLastSyncedAtMillis: Long? = entity.lastSyncedAtMillis
        if (_tmpLastSyncedAtMillis == null) {
          statement.bindNull(8)
        } else {
          statement.bindLong(8, _tmpLastSyncedAtMillis)
        }
        val _tmpRemoteVersion: String? = entity.remoteVersion
        if (_tmpRemoteVersion == null) {
          statement.bindNull(9)
        } else {
          statement.bindText(9, _tmpRemoteVersion)
        }
      }
    }, object : EntityDeleteOrUpdateAdapter<IssuePhotoEntity>() {
      protected override fun createQuery(): String = "UPDATE `issue_photos` SET `id` = ?,`issue_id` = ?,`bytes` = ?,`remote_url` = ?,`caption` = ?,`created_at` = ?,`sync_state` = ?,`last_synced_at` = ?,`remote_version` = ? WHERE `id` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: IssuePhotoEntity) {
        statement.bindText(1, entity.id)
        statement.bindText(2, entity.issueId)
        val _tmpBytes: ByteArray? = entity.bytes
        if (_tmpBytes == null) {
          statement.bindNull(3)
        } else {
          statement.bindBlob(3, _tmpBytes)
        }
        val _tmpRemoteUrl: String? = entity.remoteUrl
        if (_tmpRemoteUrl == null) {
          statement.bindNull(4)
        } else {
          statement.bindText(4, _tmpRemoteUrl)
        }
        val _tmpCaption: String? = entity.caption
        if (_tmpCaption == null) {
          statement.bindNull(5)
        } else {
          statement.bindText(5, _tmpCaption)
        }
        statement.bindLong(6, entity.createdAtMillis)
        statement.bindText(7, entity.syncState)
        val _tmpLastSyncedAtMillis: Long? = entity.lastSyncedAtMillis
        if (_tmpLastSyncedAtMillis == null) {
          statement.bindNull(8)
        } else {
          statement.bindLong(8, _tmpLastSyncedAtMillis)
        }
        val _tmpRemoteVersion: String? = entity.remoteVersion
        if (_tmpRemoteVersion == null) {
          statement.bindNull(9)
        } else {
          statement.bindText(9, _tmpRemoteVersion)
        }
        statement.bindText(10, entity.id)
      }
    })
    this.__upsertAdapterOfIssueStatusChangeEntity = EntityUpsertAdapter<IssueStatusChangeEntity>(object : EntityInsertAdapter<IssueStatusChangeEntity>() {
      protected override fun createQuery(): String = "INSERT INTO `issue_status_changes` (`id`,`issue_id`,`from_status`,`to_status`,`note`,`changed_by_user_id`,`changed_by_display_name`,`changed_at`,`sync_state`,`last_synced_at`,`remote_version`) VALUES (?,?,?,?,?,?,?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: IssueStatusChangeEntity) {
        statement.bindText(1, entity.id)
        statement.bindText(2, entity.issueId)
        val _tmpFromStatus: String? = entity.fromStatus
        if (_tmpFromStatus == null) {
          statement.bindNull(3)
        } else {
          statement.bindText(3, _tmpFromStatus)
        }
        statement.bindText(4, entity.toStatus)
        val _tmpNote: String? = entity.note
        if (_tmpNote == null) {
          statement.bindNull(5)
        } else {
          statement.bindText(5, _tmpNote)
        }
        val _tmpChangedByUserId: String? = entity.changedByUserId
        if (_tmpChangedByUserId == null) {
          statement.bindNull(6)
        } else {
          statement.bindText(6, _tmpChangedByUserId)
        }
        val _tmpChangedByDisplayName: String? = entity.changedByDisplayName
        if (_tmpChangedByDisplayName == null) {
          statement.bindNull(7)
        } else {
          statement.bindText(7, _tmpChangedByDisplayName)
        }
        statement.bindLong(8, entity.changedAtMillis)
        statement.bindText(9, entity.syncState)
        val _tmpLastSyncedAtMillis: Long? = entity.lastSyncedAtMillis
        if (_tmpLastSyncedAtMillis == null) {
          statement.bindNull(10)
        } else {
          statement.bindLong(10, _tmpLastSyncedAtMillis)
        }
        val _tmpRemoteVersion: String? = entity.remoteVersion
        if (_tmpRemoteVersion == null) {
          statement.bindNull(11)
        } else {
          statement.bindText(11, _tmpRemoteVersion)
        }
      }
    }, object : EntityDeleteOrUpdateAdapter<IssueStatusChangeEntity>() {
      protected override fun createQuery(): String = "UPDATE `issue_status_changes` SET `id` = ?,`issue_id` = ?,`from_status` = ?,`to_status` = ?,`note` = ?,`changed_by_user_id` = ?,`changed_by_display_name` = ?,`changed_at` = ?,`sync_state` = ?,`last_synced_at` = ?,`remote_version` = ? WHERE `id` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: IssueStatusChangeEntity) {
        statement.bindText(1, entity.id)
        statement.bindText(2, entity.issueId)
        val _tmpFromStatus: String? = entity.fromStatus
        if (_tmpFromStatus == null) {
          statement.bindNull(3)
        } else {
          statement.bindText(3, _tmpFromStatus)
        }
        statement.bindText(4, entity.toStatus)
        val _tmpNote: String? = entity.note
        if (_tmpNote == null) {
          statement.bindNull(5)
        } else {
          statement.bindText(5, _tmpNote)
        }
        val _tmpChangedByUserId: String? = entity.changedByUserId
        if (_tmpChangedByUserId == null) {
          statement.bindNull(6)
        } else {
          statement.bindText(6, _tmpChangedByUserId)
        }
        val _tmpChangedByDisplayName: String? = entity.changedByDisplayName
        if (_tmpChangedByDisplayName == null) {
          statement.bindNull(7)
        } else {
          statement.bindText(7, _tmpChangedByDisplayName)
        }
        statement.bindLong(8, entity.changedAtMillis)
        statement.bindText(9, entity.syncState)
        val _tmpLastSyncedAtMillis: Long? = entity.lastSyncedAtMillis
        if (_tmpLastSyncedAtMillis == null) {
          statement.bindNull(10)
        } else {
          statement.bindLong(10, _tmpLastSyncedAtMillis)
        }
        val _tmpRemoteVersion: String? = entity.remoteVersion
        if (_tmpRemoteVersion == null) {
          statement.bindNull(11)
        } else {
          statement.bindText(11, _tmpRemoteVersion)
        }
        statement.bindText(12, entity.id)
      }
    })
    this.__upsertAdapterOfIssueSupportEntity = EntityUpsertAdapter<IssueSupportEntity>(object : EntityInsertAdapter<IssueSupportEntity>() {
      protected override fun createQuery(): String = "INSERT INTO `issue_supports` (`issue_id`,`user_id`,`created_at`,`sync_state`) VALUES (?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: IssueSupportEntity) {
        statement.bindText(1, entity.issueId)
        statement.bindText(2, entity.userId)
        statement.bindLong(3, entity.createdAtMillis)
        statement.bindText(4, entity.syncState)
      }
    }, object : EntityDeleteOrUpdateAdapter<IssueSupportEntity>() {
      protected override fun createQuery(): String = "UPDATE `issue_supports` SET `issue_id` = ?,`user_id` = ?,`created_at` = ?,`sync_state` = ? WHERE `issue_id` = ? AND `user_id` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: IssueSupportEntity) {
        statement.bindText(1, entity.issueId)
        statement.bindText(2, entity.userId)
        statement.bindLong(3, entity.createdAtMillis)
        statement.bindText(4, entity.syncState)
        statement.bindText(5, entity.issueId)
        statement.bindText(6, entity.userId)
      }
    })
  }

  public override suspend fun insertSupport(support: IssueSupportEntity): Long = performSuspending(__db, false, true) { _connection ->
    val _result: Long = __insertAdapterOfIssueSupportEntity.insertAndReturnId(_connection, support)
    _result
  }

  public override suspend fun upsert(issue: IssueEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __upsertAdapterOfIssueEntity.upsert(_connection, issue)
  }

  public override suspend fun upsertAll(issues: List<IssueEntity>): Unit = performSuspending(__db, false, true) { _connection ->
    __upsertAdapterOfIssueEntity.upsert(_connection, issues)
  }

  public override suspend fun upsertPhoto(photo: IssuePhotoEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __upsertAdapterOfIssuePhotoEntity.upsert(_connection, photo)
  }

  public override suspend fun upsertStatusChange(change: IssueStatusChangeEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __upsertAdapterOfIssueStatusChangeEntity.upsert(_connection, change)
  }

  public override suspend fun upsertSupports(supports: List<IssueSupportEntity>): Unit = performSuspending(__db, false, true) { _connection ->
    __upsertAdapterOfIssueSupportEntity.upsert(_connection, supports)
  }

  public override fun observeAll(): Flow<List<IssueEntity>> {
    val _sql: String = "SELECT * FROM issues ORDER BY updated_at DESC"
    return createFlow(__db, false, arrayOf("issues")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfTitle: Int = getColumnIndexOrThrow(_stmt, "title")
        val _columnIndexOfDescription: Int = getColumnIndexOrThrow(_stmt, "description")
        val _columnIndexOfRequestedAction: Int = getColumnIndexOrThrow(_stmt, "requested_action")
        val _columnIndexOfCategory: Int = getColumnIndexOrThrow(_stmt, "category")
        val _columnIndexOfStatus: Int = getColumnIndexOrThrow(_stmt, "status")
        val _columnIndexOfPriority: Int = getColumnIndexOrThrow(_stmt, "priority")
        val _columnIndexOfLocationDescription: Int = getColumnIndexOrThrow(_stmt, "location_description")
        val _columnIndexOfLatitude: Int = getColumnIndexOrThrow(_stmt, "latitude")
        val _columnIndexOfLongitude: Int = getColumnIndexOrThrow(_stmt, "longitude")
        val _columnIndexOfGeocodedAddress: Int = getColumnIndexOrThrow(_stmt, "geocoded_address")
        val _columnIndexOfNeighborhood: Int = getColumnIndexOrThrow(_stmt, "neighborhood")
        val _columnIndexOfCouncilDistrict: Int = getColumnIndexOrThrow(_stmt, "council_district")
        val _columnIndexOfCensusTract: Int = getColumnIndexOrThrow(_stmt, "census_tract")
        val _columnIndexOfPolicePrecinct: Int = getColumnIndexOrThrow(_stmt, "police_precinct")
        val _columnIndexOfDepartmentId: Int = getColumnIndexOrThrow(_stmt, "department_id")
        val _columnIndexOfReporterName: Int = getColumnIndexOrThrow(_stmt, "reporter_name")
        val _columnIndexOfReporterEmail: Int = getColumnIndexOrThrow(_stmt, "reporter_email")
        val _columnIndexOfReporterPhone: Int = getColumnIndexOrThrow(_stmt, "reporter_phone")
        val _columnIndexOfSubmittedByUserId: Int = getColumnIndexOrThrow(_stmt, "submitted_by_user_id")
        val _columnIndexOfNotesSource: Int = getColumnIndexOrThrow(_stmt, "notes_source")
        val _columnIndexOfReviewState: Int = getColumnIndexOrThrow(_stmt, "review_state")
        val _columnIndexOfReviewedByUserId: Int = getColumnIndexOrThrow(_stmt, "reviewed_by_user_id")
        val _columnIndexOfReviewedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "reviewed_by_display_name")
        val _columnIndexOfReviewedAtMillis: Int = getColumnIndexOrThrow(_stmt, "reviewed_at")
        val _columnIndexOfRejectionReason: Int = getColumnIndexOrThrow(_stmt, "rejection_reason")
        val _columnIndexOfEditedByUserId: Int = getColumnIndexOrThrow(_stmt, "edited_by_user_id")
        val _columnIndexOfEditedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "edited_by_display_name")
        val _columnIndexOfEditedAtMillis: Int = getColumnIndexOrThrow(_stmt, "edited_at")
        val _columnIndexOfEditRevision: Int = getColumnIndexOrThrow(_stmt, "edit_revision")
        val _columnIndexOfEditedFields: Int = getColumnIndexOrThrow(_stmt, "edited_fields")
        val _columnIndexOfResolution: Int = getColumnIndexOrThrow(_stmt, "resolution")
        val _columnIndexOfExternalSystem: Int = getColumnIndexOrThrow(_stmt, "external_system")
        val _columnIndexOfExternalReferenceNumber: Int = getColumnIndexOrThrow(_stmt, "external_reference_number")
        val _columnIndexOfExternalSubmittedAtMillis: Int = getColumnIndexOrThrow(_stmt, "external_submitted_at")
        val _columnIndexOfExternalLastCheckedAtMillis: Int = getColumnIndexOrThrow(_stmt, "external_last_checked_at")
        val _columnIndexOfExternalReportedStatus: Int = getColumnIndexOrThrow(_stmt, "external_reported_status")
        val _columnIndexOfSupportCount: Int = getColumnIndexOrThrow(_stmt, "support_count")
        val _columnIndexOfCreatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "created_at")
        val _columnIndexOfUpdatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "updated_at")
        val _columnIndexOfSyncState: Int = getColumnIndexOrThrow(_stmt, "sync_state")
        val _columnIndexOfLastSyncedAtMillis: Int = getColumnIndexOrThrow(_stmt, "last_synced_at")
        val _columnIndexOfRemoteVersion: Int = getColumnIndexOrThrow(_stmt, "remote_version")
        val _result: MutableList<IssueEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: IssueEntity
          val _tmpId: String
          _tmpId = _stmt.getText(_columnIndexOfId)
          val _tmpTitle: String
          _tmpTitle = _stmt.getText(_columnIndexOfTitle)
          val _tmpDescription: String
          _tmpDescription = _stmt.getText(_columnIndexOfDescription)
          val _tmpRequestedAction: String
          _tmpRequestedAction = _stmt.getText(_columnIndexOfRequestedAction)
          val _tmpCategory: String
          _tmpCategory = _stmt.getText(_columnIndexOfCategory)
          val _tmpStatus: String
          _tmpStatus = _stmt.getText(_columnIndexOfStatus)
          val _tmpPriority: String
          _tmpPriority = _stmt.getText(_columnIndexOfPriority)
          val _tmpLocationDescription: String
          _tmpLocationDescription = _stmt.getText(_columnIndexOfLocationDescription)
          val _tmpLatitude: Double?
          if (_stmt.isNull(_columnIndexOfLatitude)) {
            _tmpLatitude = null
          } else {
            _tmpLatitude = _stmt.getDouble(_columnIndexOfLatitude)
          }
          val _tmpLongitude: Double?
          if (_stmt.isNull(_columnIndexOfLongitude)) {
            _tmpLongitude = null
          } else {
            _tmpLongitude = _stmt.getDouble(_columnIndexOfLongitude)
          }
          val _tmpGeocodedAddress: String?
          if (_stmt.isNull(_columnIndexOfGeocodedAddress)) {
            _tmpGeocodedAddress = null
          } else {
            _tmpGeocodedAddress = _stmt.getText(_columnIndexOfGeocodedAddress)
          }
          val _tmpNeighborhood: String?
          if (_stmt.isNull(_columnIndexOfNeighborhood)) {
            _tmpNeighborhood = null
          } else {
            _tmpNeighborhood = _stmt.getText(_columnIndexOfNeighborhood)
          }
          val _tmpCouncilDistrict: String?
          if (_stmt.isNull(_columnIndexOfCouncilDistrict)) {
            _tmpCouncilDistrict = null
          } else {
            _tmpCouncilDistrict = _stmt.getText(_columnIndexOfCouncilDistrict)
          }
          val _tmpCensusTract: String?
          if (_stmt.isNull(_columnIndexOfCensusTract)) {
            _tmpCensusTract = null
          } else {
            _tmpCensusTract = _stmt.getText(_columnIndexOfCensusTract)
          }
          val _tmpPolicePrecinct: String?
          if (_stmt.isNull(_columnIndexOfPolicePrecinct)) {
            _tmpPolicePrecinct = null
          } else {
            _tmpPolicePrecinct = _stmt.getText(_columnIndexOfPolicePrecinct)
          }
          val _tmpDepartmentId: String?
          if (_stmt.isNull(_columnIndexOfDepartmentId)) {
            _tmpDepartmentId = null
          } else {
            _tmpDepartmentId = _stmt.getText(_columnIndexOfDepartmentId)
          }
          val _tmpReporterName: String?
          if (_stmt.isNull(_columnIndexOfReporterName)) {
            _tmpReporterName = null
          } else {
            _tmpReporterName = _stmt.getText(_columnIndexOfReporterName)
          }
          val _tmpReporterEmail: String?
          if (_stmt.isNull(_columnIndexOfReporterEmail)) {
            _tmpReporterEmail = null
          } else {
            _tmpReporterEmail = _stmt.getText(_columnIndexOfReporterEmail)
          }
          val _tmpReporterPhone: String?
          if (_stmt.isNull(_columnIndexOfReporterPhone)) {
            _tmpReporterPhone = null
          } else {
            _tmpReporterPhone = _stmt.getText(_columnIndexOfReporterPhone)
          }
          val _tmpSubmittedByUserId: String?
          if (_stmt.isNull(_columnIndexOfSubmittedByUserId)) {
            _tmpSubmittedByUserId = null
          } else {
            _tmpSubmittedByUserId = _stmt.getText(_columnIndexOfSubmittedByUserId)
          }
          val _tmpNotesSource: String
          _tmpNotesSource = _stmt.getText(_columnIndexOfNotesSource)
          val _tmpReviewState: String
          _tmpReviewState = _stmt.getText(_columnIndexOfReviewState)
          val _tmpReviewedByUserId: String?
          if (_stmt.isNull(_columnIndexOfReviewedByUserId)) {
            _tmpReviewedByUserId = null
          } else {
            _tmpReviewedByUserId = _stmt.getText(_columnIndexOfReviewedByUserId)
          }
          val _tmpReviewedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfReviewedByDisplayName)) {
            _tmpReviewedByDisplayName = null
          } else {
            _tmpReviewedByDisplayName = _stmt.getText(_columnIndexOfReviewedByDisplayName)
          }
          val _tmpReviewedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfReviewedAtMillis)) {
            _tmpReviewedAtMillis = null
          } else {
            _tmpReviewedAtMillis = _stmt.getLong(_columnIndexOfReviewedAtMillis)
          }
          val _tmpRejectionReason: String?
          if (_stmt.isNull(_columnIndexOfRejectionReason)) {
            _tmpRejectionReason = null
          } else {
            _tmpRejectionReason = _stmt.getText(_columnIndexOfRejectionReason)
          }
          val _tmpEditedByUserId: String?
          if (_stmt.isNull(_columnIndexOfEditedByUserId)) {
            _tmpEditedByUserId = null
          } else {
            _tmpEditedByUserId = _stmt.getText(_columnIndexOfEditedByUserId)
          }
          val _tmpEditedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfEditedByDisplayName)) {
            _tmpEditedByDisplayName = null
          } else {
            _tmpEditedByDisplayName = _stmt.getText(_columnIndexOfEditedByDisplayName)
          }
          val _tmpEditedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfEditedAtMillis)) {
            _tmpEditedAtMillis = null
          } else {
            _tmpEditedAtMillis = _stmt.getLong(_columnIndexOfEditedAtMillis)
          }
          val _tmpEditRevision: Int?
          if (_stmt.isNull(_columnIndexOfEditRevision)) {
            _tmpEditRevision = null
          } else {
            _tmpEditRevision = _stmt.getLong(_columnIndexOfEditRevision).toInt()
          }
          val _tmpEditedFields: String?
          if (_stmt.isNull(_columnIndexOfEditedFields)) {
            _tmpEditedFields = null
          } else {
            _tmpEditedFields = _stmt.getText(_columnIndexOfEditedFields)
          }
          val _tmpResolution: String?
          if (_stmt.isNull(_columnIndexOfResolution)) {
            _tmpResolution = null
          } else {
            _tmpResolution = _stmt.getText(_columnIndexOfResolution)
          }
          val _tmpExternalSystem: String?
          if (_stmt.isNull(_columnIndexOfExternalSystem)) {
            _tmpExternalSystem = null
          } else {
            _tmpExternalSystem = _stmt.getText(_columnIndexOfExternalSystem)
          }
          val _tmpExternalReferenceNumber: String?
          if (_stmt.isNull(_columnIndexOfExternalReferenceNumber)) {
            _tmpExternalReferenceNumber = null
          } else {
            _tmpExternalReferenceNumber = _stmt.getText(_columnIndexOfExternalReferenceNumber)
          }
          val _tmpExternalSubmittedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfExternalSubmittedAtMillis)) {
            _tmpExternalSubmittedAtMillis = null
          } else {
            _tmpExternalSubmittedAtMillis = _stmt.getLong(_columnIndexOfExternalSubmittedAtMillis)
          }
          val _tmpExternalLastCheckedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfExternalLastCheckedAtMillis)) {
            _tmpExternalLastCheckedAtMillis = null
          } else {
            _tmpExternalLastCheckedAtMillis = _stmt.getLong(_columnIndexOfExternalLastCheckedAtMillis)
          }
          val _tmpExternalReportedStatus: String?
          if (_stmt.isNull(_columnIndexOfExternalReportedStatus)) {
            _tmpExternalReportedStatus = null
          } else {
            _tmpExternalReportedStatus = _stmt.getText(_columnIndexOfExternalReportedStatus)
          }
          val _tmpSupportCount: Int
          _tmpSupportCount = _stmt.getLong(_columnIndexOfSupportCount).toInt()
          val _tmpCreatedAtMillis: Long
          _tmpCreatedAtMillis = _stmt.getLong(_columnIndexOfCreatedAtMillis)
          val _tmpUpdatedAtMillis: Long
          _tmpUpdatedAtMillis = _stmt.getLong(_columnIndexOfUpdatedAtMillis)
          val _tmpSyncState: String
          _tmpSyncState = _stmt.getText(_columnIndexOfSyncState)
          val _tmpLastSyncedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfLastSyncedAtMillis)) {
            _tmpLastSyncedAtMillis = null
          } else {
            _tmpLastSyncedAtMillis = _stmt.getLong(_columnIndexOfLastSyncedAtMillis)
          }
          val _tmpRemoteVersion: String?
          if (_stmt.isNull(_columnIndexOfRemoteVersion)) {
            _tmpRemoteVersion = null
          } else {
            _tmpRemoteVersion = _stmt.getText(_columnIndexOfRemoteVersion)
          }
          _item = IssueEntity(_tmpId,_tmpTitle,_tmpDescription,_tmpRequestedAction,_tmpCategory,_tmpStatus,_tmpPriority,_tmpLocationDescription,_tmpLatitude,_tmpLongitude,_tmpGeocodedAddress,_tmpNeighborhood,_tmpCouncilDistrict,_tmpCensusTract,_tmpPolicePrecinct,_tmpDepartmentId,_tmpReporterName,_tmpReporterEmail,_tmpReporterPhone,_tmpSubmittedByUserId,_tmpNotesSource,_tmpReviewState,_tmpReviewedByUserId,_tmpReviewedByDisplayName,_tmpReviewedAtMillis,_tmpRejectionReason,_tmpEditedByUserId,_tmpEditedByDisplayName,_tmpEditedAtMillis,_tmpEditRevision,_tmpEditedFields,_tmpResolution,_tmpExternalSystem,_tmpExternalReferenceNumber,_tmpExternalSubmittedAtMillis,_tmpExternalLastCheckedAtMillis,_tmpExternalReportedStatus,_tmpSupportCount,_tmpCreatedAtMillis,_tmpUpdatedAtMillis,_tmpSyncState,_tmpLastSyncedAtMillis,_tmpRemoteVersion)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun observeById(id: String): Flow<IssueEntity?> {
    val _sql: String = "SELECT * FROM issues WHERE id = ?"
    return createFlow(__db, false, arrayOf("issues")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, id)
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfTitle: Int = getColumnIndexOrThrow(_stmt, "title")
        val _columnIndexOfDescription: Int = getColumnIndexOrThrow(_stmt, "description")
        val _columnIndexOfRequestedAction: Int = getColumnIndexOrThrow(_stmt, "requested_action")
        val _columnIndexOfCategory: Int = getColumnIndexOrThrow(_stmt, "category")
        val _columnIndexOfStatus: Int = getColumnIndexOrThrow(_stmt, "status")
        val _columnIndexOfPriority: Int = getColumnIndexOrThrow(_stmt, "priority")
        val _columnIndexOfLocationDescription: Int = getColumnIndexOrThrow(_stmt, "location_description")
        val _columnIndexOfLatitude: Int = getColumnIndexOrThrow(_stmt, "latitude")
        val _columnIndexOfLongitude: Int = getColumnIndexOrThrow(_stmt, "longitude")
        val _columnIndexOfGeocodedAddress: Int = getColumnIndexOrThrow(_stmt, "geocoded_address")
        val _columnIndexOfNeighborhood: Int = getColumnIndexOrThrow(_stmt, "neighborhood")
        val _columnIndexOfCouncilDistrict: Int = getColumnIndexOrThrow(_stmt, "council_district")
        val _columnIndexOfCensusTract: Int = getColumnIndexOrThrow(_stmt, "census_tract")
        val _columnIndexOfPolicePrecinct: Int = getColumnIndexOrThrow(_stmt, "police_precinct")
        val _columnIndexOfDepartmentId: Int = getColumnIndexOrThrow(_stmt, "department_id")
        val _columnIndexOfReporterName: Int = getColumnIndexOrThrow(_stmt, "reporter_name")
        val _columnIndexOfReporterEmail: Int = getColumnIndexOrThrow(_stmt, "reporter_email")
        val _columnIndexOfReporterPhone: Int = getColumnIndexOrThrow(_stmt, "reporter_phone")
        val _columnIndexOfSubmittedByUserId: Int = getColumnIndexOrThrow(_stmt, "submitted_by_user_id")
        val _columnIndexOfNotesSource: Int = getColumnIndexOrThrow(_stmt, "notes_source")
        val _columnIndexOfReviewState: Int = getColumnIndexOrThrow(_stmt, "review_state")
        val _columnIndexOfReviewedByUserId: Int = getColumnIndexOrThrow(_stmt, "reviewed_by_user_id")
        val _columnIndexOfReviewedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "reviewed_by_display_name")
        val _columnIndexOfReviewedAtMillis: Int = getColumnIndexOrThrow(_stmt, "reviewed_at")
        val _columnIndexOfRejectionReason: Int = getColumnIndexOrThrow(_stmt, "rejection_reason")
        val _columnIndexOfEditedByUserId: Int = getColumnIndexOrThrow(_stmt, "edited_by_user_id")
        val _columnIndexOfEditedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "edited_by_display_name")
        val _columnIndexOfEditedAtMillis: Int = getColumnIndexOrThrow(_stmt, "edited_at")
        val _columnIndexOfEditRevision: Int = getColumnIndexOrThrow(_stmt, "edit_revision")
        val _columnIndexOfEditedFields: Int = getColumnIndexOrThrow(_stmt, "edited_fields")
        val _columnIndexOfResolution: Int = getColumnIndexOrThrow(_stmt, "resolution")
        val _columnIndexOfExternalSystem: Int = getColumnIndexOrThrow(_stmt, "external_system")
        val _columnIndexOfExternalReferenceNumber: Int = getColumnIndexOrThrow(_stmt, "external_reference_number")
        val _columnIndexOfExternalSubmittedAtMillis: Int = getColumnIndexOrThrow(_stmt, "external_submitted_at")
        val _columnIndexOfExternalLastCheckedAtMillis: Int = getColumnIndexOrThrow(_stmt, "external_last_checked_at")
        val _columnIndexOfExternalReportedStatus: Int = getColumnIndexOrThrow(_stmt, "external_reported_status")
        val _columnIndexOfSupportCount: Int = getColumnIndexOrThrow(_stmt, "support_count")
        val _columnIndexOfCreatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "created_at")
        val _columnIndexOfUpdatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "updated_at")
        val _columnIndexOfSyncState: Int = getColumnIndexOrThrow(_stmt, "sync_state")
        val _columnIndexOfLastSyncedAtMillis: Int = getColumnIndexOrThrow(_stmt, "last_synced_at")
        val _columnIndexOfRemoteVersion: Int = getColumnIndexOrThrow(_stmt, "remote_version")
        val _result: IssueEntity?
        if (_stmt.step()) {
          val _tmpId: String
          _tmpId = _stmt.getText(_columnIndexOfId)
          val _tmpTitle: String
          _tmpTitle = _stmt.getText(_columnIndexOfTitle)
          val _tmpDescription: String
          _tmpDescription = _stmt.getText(_columnIndexOfDescription)
          val _tmpRequestedAction: String
          _tmpRequestedAction = _stmt.getText(_columnIndexOfRequestedAction)
          val _tmpCategory: String
          _tmpCategory = _stmt.getText(_columnIndexOfCategory)
          val _tmpStatus: String
          _tmpStatus = _stmt.getText(_columnIndexOfStatus)
          val _tmpPriority: String
          _tmpPriority = _stmt.getText(_columnIndexOfPriority)
          val _tmpLocationDescription: String
          _tmpLocationDescription = _stmt.getText(_columnIndexOfLocationDescription)
          val _tmpLatitude: Double?
          if (_stmt.isNull(_columnIndexOfLatitude)) {
            _tmpLatitude = null
          } else {
            _tmpLatitude = _stmt.getDouble(_columnIndexOfLatitude)
          }
          val _tmpLongitude: Double?
          if (_stmt.isNull(_columnIndexOfLongitude)) {
            _tmpLongitude = null
          } else {
            _tmpLongitude = _stmt.getDouble(_columnIndexOfLongitude)
          }
          val _tmpGeocodedAddress: String?
          if (_stmt.isNull(_columnIndexOfGeocodedAddress)) {
            _tmpGeocodedAddress = null
          } else {
            _tmpGeocodedAddress = _stmt.getText(_columnIndexOfGeocodedAddress)
          }
          val _tmpNeighborhood: String?
          if (_stmt.isNull(_columnIndexOfNeighborhood)) {
            _tmpNeighborhood = null
          } else {
            _tmpNeighborhood = _stmt.getText(_columnIndexOfNeighborhood)
          }
          val _tmpCouncilDistrict: String?
          if (_stmt.isNull(_columnIndexOfCouncilDistrict)) {
            _tmpCouncilDistrict = null
          } else {
            _tmpCouncilDistrict = _stmt.getText(_columnIndexOfCouncilDistrict)
          }
          val _tmpCensusTract: String?
          if (_stmt.isNull(_columnIndexOfCensusTract)) {
            _tmpCensusTract = null
          } else {
            _tmpCensusTract = _stmt.getText(_columnIndexOfCensusTract)
          }
          val _tmpPolicePrecinct: String?
          if (_stmt.isNull(_columnIndexOfPolicePrecinct)) {
            _tmpPolicePrecinct = null
          } else {
            _tmpPolicePrecinct = _stmt.getText(_columnIndexOfPolicePrecinct)
          }
          val _tmpDepartmentId: String?
          if (_stmt.isNull(_columnIndexOfDepartmentId)) {
            _tmpDepartmentId = null
          } else {
            _tmpDepartmentId = _stmt.getText(_columnIndexOfDepartmentId)
          }
          val _tmpReporterName: String?
          if (_stmt.isNull(_columnIndexOfReporterName)) {
            _tmpReporterName = null
          } else {
            _tmpReporterName = _stmt.getText(_columnIndexOfReporterName)
          }
          val _tmpReporterEmail: String?
          if (_stmt.isNull(_columnIndexOfReporterEmail)) {
            _tmpReporterEmail = null
          } else {
            _tmpReporterEmail = _stmt.getText(_columnIndexOfReporterEmail)
          }
          val _tmpReporterPhone: String?
          if (_stmt.isNull(_columnIndexOfReporterPhone)) {
            _tmpReporterPhone = null
          } else {
            _tmpReporterPhone = _stmt.getText(_columnIndexOfReporterPhone)
          }
          val _tmpSubmittedByUserId: String?
          if (_stmt.isNull(_columnIndexOfSubmittedByUserId)) {
            _tmpSubmittedByUserId = null
          } else {
            _tmpSubmittedByUserId = _stmt.getText(_columnIndexOfSubmittedByUserId)
          }
          val _tmpNotesSource: String
          _tmpNotesSource = _stmt.getText(_columnIndexOfNotesSource)
          val _tmpReviewState: String
          _tmpReviewState = _stmt.getText(_columnIndexOfReviewState)
          val _tmpReviewedByUserId: String?
          if (_stmt.isNull(_columnIndexOfReviewedByUserId)) {
            _tmpReviewedByUserId = null
          } else {
            _tmpReviewedByUserId = _stmt.getText(_columnIndexOfReviewedByUserId)
          }
          val _tmpReviewedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfReviewedByDisplayName)) {
            _tmpReviewedByDisplayName = null
          } else {
            _tmpReviewedByDisplayName = _stmt.getText(_columnIndexOfReviewedByDisplayName)
          }
          val _tmpReviewedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfReviewedAtMillis)) {
            _tmpReviewedAtMillis = null
          } else {
            _tmpReviewedAtMillis = _stmt.getLong(_columnIndexOfReviewedAtMillis)
          }
          val _tmpRejectionReason: String?
          if (_stmt.isNull(_columnIndexOfRejectionReason)) {
            _tmpRejectionReason = null
          } else {
            _tmpRejectionReason = _stmt.getText(_columnIndexOfRejectionReason)
          }
          val _tmpEditedByUserId: String?
          if (_stmt.isNull(_columnIndexOfEditedByUserId)) {
            _tmpEditedByUserId = null
          } else {
            _tmpEditedByUserId = _stmt.getText(_columnIndexOfEditedByUserId)
          }
          val _tmpEditedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfEditedByDisplayName)) {
            _tmpEditedByDisplayName = null
          } else {
            _tmpEditedByDisplayName = _stmt.getText(_columnIndexOfEditedByDisplayName)
          }
          val _tmpEditedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfEditedAtMillis)) {
            _tmpEditedAtMillis = null
          } else {
            _tmpEditedAtMillis = _stmt.getLong(_columnIndexOfEditedAtMillis)
          }
          val _tmpEditRevision: Int?
          if (_stmt.isNull(_columnIndexOfEditRevision)) {
            _tmpEditRevision = null
          } else {
            _tmpEditRevision = _stmt.getLong(_columnIndexOfEditRevision).toInt()
          }
          val _tmpEditedFields: String?
          if (_stmt.isNull(_columnIndexOfEditedFields)) {
            _tmpEditedFields = null
          } else {
            _tmpEditedFields = _stmt.getText(_columnIndexOfEditedFields)
          }
          val _tmpResolution: String?
          if (_stmt.isNull(_columnIndexOfResolution)) {
            _tmpResolution = null
          } else {
            _tmpResolution = _stmt.getText(_columnIndexOfResolution)
          }
          val _tmpExternalSystem: String?
          if (_stmt.isNull(_columnIndexOfExternalSystem)) {
            _tmpExternalSystem = null
          } else {
            _tmpExternalSystem = _stmt.getText(_columnIndexOfExternalSystem)
          }
          val _tmpExternalReferenceNumber: String?
          if (_stmt.isNull(_columnIndexOfExternalReferenceNumber)) {
            _tmpExternalReferenceNumber = null
          } else {
            _tmpExternalReferenceNumber = _stmt.getText(_columnIndexOfExternalReferenceNumber)
          }
          val _tmpExternalSubmittedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfExternalSubmittedAtMillis)) {
            _tmpExternalSubmittedAtMillis = null
          } else {
            _tmpExternalSubmittedAtMillis = _stmt.getLong(_columnIndexOfExternalSubmittedAtMillis)
          }
          val _tmpExternalLastCheckedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfExternalLastCheckedAtMillis)) {
            _tmpExternalLastCheckedAtMillis = null
          } else {
            _tmpExternalLastCheckedAtMillis = _stmt.getLong(_columnIndexOfExternalLastCheckedAtMillis)
          }
          val _tmpExternalReportedStatus: String?
          if (_stmt.isNull(_columnIndexOfExternalReportedStatus)) {
            _tmpExternalReportedStatus = null
          } else {
            _tmpExternalReportedStatus = _stmt.getText(_columnIndexOfExternalReportedStatus)
          }
          val _tmpSupportCount: Int
          _tmpSupportCount = _stmt.getLong(_columnIndexOfSupportCount).toInt()
          val _tmpCreatedAtMillis: Long
          _tmpCreatedAtMillis = _stmt.getLong(_columnIndexOfCreatedAtMillis)
          val _tmpUpdatedAtMillis: Long
          _tmpUpdatedAtMillis = _stmt.getLong(_columnIndexOfUpdatedAtMillis)
          val _tmpSyncState: String
          _tmpSyncState = _stmt.getText(_columnIndexOfSyncState)
          val _tmpLastSyncedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfLastSyncedAtMillis)) {
            _tmpLastSyncedAtMillis = null
          } else {
            _tmpLastSyncedAtMillis = _stmt.getLong(_columnIndexOfLastSyncedAtMillis)
          }
          val _tmpRemoteVersion: String?
          if (_stmt.isNull(_columnIndexOfRemoteVersion)) {
            _tmpRemoteVersion = null
          } else {
            _tmpRemoteVersion = _stmt.getText(_columnIndexOfRemoteVersion)
          }
          _result = IssueEntity(_tmpId,_tmpTitle,_tmpDescription,_tmpRequestedAction,_tmpCategory,_tmpStatus,_tmpPriority,_tmpLocationDescription,_tmpLatitude,_tmpLongitude,_tmpGeocodedAddress,_tmpNeighborhood,_tmpCouncilDistrict,_tmpCensusTract,_tmpPolicePrecinct,_tmpDepartmentId,_tmpReporterName,_tmpReporterEmail,_tmpReporterPhone,_tmpSubmittedByUserId,_tmpNotesSource,_tmpReviewState,_tmpReviewedByUserId,_tmpReviewedByDisplayName,_tmpReviewedAtMillis,_tmpRejectionReason,_tmpEditedByUserId,_tmpEditedByDisplayName,_tmpEditedAtMillis,_tmpEditRevision,_tmpEditedFields,_tmpResolution,_tmpExternalSystem,_tmpExternalReferenceNumber,_tmpExternalSubmittedAtMillis,_tmpExternalLastCheckedAtMillis,_tmpExternalReportedStatus,_tmpSupportCount,_tmpCreatedAtMillis,_tmpUpdatedAtMillis,_tmpSyncState,_tmpLastSyncedAtMillis,_tmpRemoteVersion)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getById(id: String): IssueEntity? {
    val _sql: String = "SELECT * FROM issues WHERE id = ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, id)
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfTitle: Int = getColumnIndexOrThrow(_stmt, "title")
        val _columnIndexOfDescription: Int = getColumnIndexOrThrow(_stmt, "description")
        val _columnIndexOfRequestedAction: Int = getColumnIndexOrThrow(_stmt, "requested_action")
        val _columnIndexOfCategory: Int = getColumnIndexOrThrow(_stmt, "category")
        val _columnIndexOfStatus: Int = getColumnIndexOrThrow(_stmt, "status")
        val _columnIndexOfPriority: Int = getColumnIndexOrThrow(_stmt, "priority")
        val _columnIndexOfLocationDescription: Int = getColumnIndexOrThrow(_stmt, "location_description")
        val _columnIndexOfLatitude: Int = getColumnIndexOrThrow(_stmt, "latitude")
        val _columnIndexOfLongitude: Int = getColumnIndexOrThrow(_stmt, "longitude")
        val _columnIndexOfGeocodedAddress: Int = getColumnIndexOrThrow(_stmt, "geocoded_address")
        val _columnIndexOfNeighborhood: Int = getColumnIndexOrThrow(_stmt, "neighborhood")
        val _columnIndexOfCouncilDistrict: Int = getColumnIndexOrThrow(_stmt, "council_district")
        val _columnIndexOfCensusTract: Int = getColumnIndexOrThrow(_stmt, "census_tract")
        val _columnIndexOfPolicePrecinct: Int = getColumnIndexOrThrow(_stmt, "police_precinct")
        val _columnIndexOfDepartmentId: Int = getColumnIndexOrThrow(_stmt, "department_id")
        val _columnIndexOfReporterName: Int = getColumnIndexOrThrow(_stmt, "reporter_name")
        val _columnIndexOfReporterEmail: Int = getColumnIndexOrThrow(_stmt, "reporter_email")
        val _columnIndexOfReporterPhone: Int = getColumnIndexOrThrow(_stmt, "reporter_phone")
        val _columnIndexOfSubmittedByUserId: Int = getColumnIndexOrThrow(_stmt, "submitted_by_user_id")
        val _columnIndexOfNotesSource: Int = getColumnIndexOrThrow(_stmt, "notes_source")
        val _columnIndexOfReviewState: Int = getColumnIndexOrThrow(_stmt, "review_state")
        val _columnIndexOfReviewedByUserId: Int = getColumnIndexOrThrow(_stmt, "reviewed_by_user_id")
        val _columnIndexOfReviewedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "reviewed_by_display_name")
        val _columnIndexOfReviewedAtMillis: Int = getColumnIndexOrThrow(_stmt, "reviewed_at")
        val _columnIndexOfRejectionReason: Int = getColumnIndexOrThrow(_stmt, "rejection_reason")
        val _columnIndexOfEditedByUserId: Int = getColumnIndexOrThrow(_stmt, "edited_by_user_id")
        val _columnIndexOfEditedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "edited_by_display_name")
        val _columnIndexOfEditedAtMillis: Int = getColumnIndexOrThrow(_stmt, "edited_at")
        val _columnIndexOfEditRevision: Int = getColumnIndexOrThrow(_stmt, "edit_revision")
        val _columnIndexOfEditedFields: Int = getColumnIndexOrThrow(_stmt, "edited_fields")
        val _columnIndexOfResolution: Int = getColumnIndexOrThrow(_stmt, "resolution")
        val _columnIndexOfExternalSystem: Int = getColumnIndexOrThrow(_stmt, "external_system")
        val _columnIndexOfExternalReferenceNumber: Int = getColumnIndexOrThrow(_stmt, "external_reference_number")
        val _columnIndexOfExternalSubmittedAtMillis: Int = getColumnIndexOrThrow(_stmt, "external_submitted_at")
        val _columnIndexOfExternalLastCheckedAtMillis: Int = getColumnIndexOrThrow(_stmt, "external_last_checked_at")
        val _columnIndexOfExternalReportedStatus: Int = getColumnIndexOrThrow(_stmt, "external_reported_status")
        val _columnIndexOfSupportCount: Int = getColumnIndexOrThrow(_stmt, "support_count")
        val _columnIndexOfCreatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "created_at")
        val _columnIndexOfUpdatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "updated_at")
        val _columnIndexOfSyncState: Int = getColumnIndexOrThrow(_stmt, "sync_state")
        val _columnIndexOfLastSyncedAtMillis: Int = getColumnIndexOrThrow(_stmt, "last_synced_at")
        val _columnIndexOfRemoteVersion: Int = getColumnIndexOrThrow(_stmt, "remote_version")
        val _result: IssueEntity?
        if (_stmt.step()) {
          val _tmpId: String
          _tmpId = _stmt.getText(_columnIndexOfId)
          val _tmpTitle: String
          _tmpTitle = _stmt.getText(_columnIndexOfTitle)
          val _tmpDescription: String
          _tmpDescription = _stmt.getText(_columnIndexOfDescription)
          val _tmpRequestedAction: String
          _tmpRequestedAction = _stmt.getText(_columnIndexOfRequestedAction)
          val _tmpCategory: String
          _tmpCategory = _stmt.getText(_columnIndexOfCategory)
          val _tmpStatus: String
          _tmpStatus = _stmt.getText(_columnIndexOfStatus)
          val _tmpPriority: String
          _tmpPriority = _stmt.getText(_columnIndexOfPriority)
          val _tmpLocationDescription: String
          _tmpLocationDescription = _stmt.getText(_columnIndexOfLocationDescription)
          val _tmpLatitude: Double?
          if (_stmt.isNull(_columnIndexOfLatitude)) {
            _tmpLatitude = null
          } else {
            _tmpLatitude = _stmt.getDouble(_columnIndexOfLatitude)
          }
          val _tmpLongitude: Double?
          if (_stmt.isNull(_columnIndexOfLongitude)) {
            _tmpLongitude = null
          } else {
            _tmpLongitude = _stmt.getDouble(_columnIndexOfLongitude)
          }
          val _tmpGeocodedAddress: String?
          if (_stmt.isNull(_columnIndexOfGeocodedAddress)) {
            _tmpGeocodedAddress = null
          } else {
            _tmpGeocodedAddress = _stmt.getText(_columnIndexOfGeocodedAddress)
          }
          val _tmpNeighborhood: String?
          if (_stmt.isNull(_columnIndexOfNeighborhood)) {
            _tmpNeighborhood = null
          } else {
            _tmpNeighborhood = _stmt.getText(_columnIndexOfNeighborhood)
          }
          val _tmpCouncilDistrict: String?
          if (_stmt.isNull(_columnIndexOfCouncilDistrict)) {
            _tmpCouncilDistrict = null
          } else {
            _tmpCouncilDistrict = _stmt.getText(_columnIndexOfCouncilDistrict)
          }
          val _tmpCensusTract: String?
          if (_stmt.isNull(_columnIndexOfCensusTract)) {
            _tmpCensusTract = null
          } else {
            _tmpCensusTract = _stmt.getText(_columnIndexOfCensusTract)
          }
          val _tmpPolicePrecinct: String?
          if (_stmt.isNull(_columnIndexOfPolicePrecinct)) {
            _tmpPolicePrecinct = null
          } else {
            _tmpPolicePrecinct = _stmt.getText(_columnIndexOfPolicePrecinct)
          }
          val _tmpDepartmentId: String?
          if (_stmt.isNull(_columnIndexOfDepartmentId)) {
            _tmpDepartmentId = null
          } else {
            _tmpDepartmentId = _stmt.getText(_columnIndexOfDepartmentId)
          }
          val _tmpReporterName: String?
          if (_stmt.isNull(_columnIndexOfReporterName)) {
            _tmpReporterName = null
          } else {
            _tmpReporterName = _stmt.getText(_columnIndexOfReporterName)
          }
          val _tmpReporterEmail: String?
          if (_stmt.isNull(_columnIndexOfReporterEmail)) {
            _tmpReporterEmail = null
          } else {
            _tmpReporterEmail = _stmt.getText(_columnIndexOfReporterEmail)
          }
          val _tmpReporterPhone: String?
          if (_stmt.isNull(_columnIndexOfReporterPhone)) {
            _tmpReporterPhone = null
          } else {
            _tmpReporterPhone = _stmt.getText(_columnIndexOfReporterPhone)
          }
          val _tmpSubmittedByUserId: String?
          if (_stmt.isNull(_columnIndexOfSubmittedByUserId)) {
            _tmpSubmittedByUserId = null
          } else {
            _tmpSubmittedByUserId = _stmt.getText(_columnIndexOfSubmittedByUserId)
          }
          val _tmpNotesSource: String
          _tmpNotesSource = _stmt.getText(_columnIndexOfNotesSource)
          val _tmpReviewState: String
          _tmpReviewState = _stmt.getText(_columnIndexOfReviewState)
          val _tmpReviewedByUserId: String?
          if (_stmt.isNull(_columnIndexOfReviewedByUserId)) {
            _tmpReviewedByUserId = null
          } else {
            _tmpReviewedByUserId = _stmt.getText(_columnIndexOfReviewedByUserId)
          }
          val _tmpReviewedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfReviewedByDisplayName)) {
            _tmpReviewedByDisplayName = null
          } else {
            _tmpReviewedByDisplayName = _stmt.getText(_columnIndexOfReviewedByDisplayName)
          }
          val _tmpReviewedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfReviewedAtMillis)) {
            _tmpReviewedAtMillis = null
          } else {
            _tmpReviewedAtMillis = _stmt.getLong(_columnIndexOfReviewedAtMillis)
          }
          val _tmpRejectionReason: String?
          if (_stmt.isNull(_columnIndexOfRejectionReason)) {
            _tmpRejectionReason = null
          } else {
            _tmpRejectionReason = _stmt.getText(_columnIndexOfRejectionReason)
          }
          val _tmpEditedByUserId: String?
          if (_stmt.isNull(_columnIndexOfEditedByUserId)) {
            _tmpEditedByUserId = null
          } else {
            _tmpEditedByUserId = _stmt.getText(_columnIndexOfEditedByUserId)
          }
          val _tmpEditedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfEditedByDisplayName)) {
            _tmpEditedByDisplayName = null
          } else {
            _tmpEditedByDisplayName = _stmt.getText(_columnIndexOfEditedByDisplayName)
          }
          val _tmpEditedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfEditedAtMillis)) {
            _tmpEditedAtMillis = null
          } else {
            _tmpEditedAtMillis = _stmt.getLong(_columnIndexOfEditedAtMillis)
          }
          val _tmpEditRevision: Int?
          if (_stmt.isNull(_columnIndexOfEditRevision)) {
            _tmpEditRevision = null
          } else {
            _tmpEditRevision = _stmt.getLong(_columnIndexOfEditRevision).toInt()
          }
          val _tmpEditedFields: String?
          if (_stmt.isNull(_columnIndexOfEditedFields)) {
            _tmpEditedFields = null
          } else {
            _tmpEditedFields = _stmt.getText(_columnIndexOfEditedFields)
          }
          val _tmpResolution: String?
          if (_stmt.isNull(_columnIndexOfResolution)) {
            _tmpResolution = null
          } else {
            _tmpResolution = _stmt.getText(_columnIndexOfResolution)
          }
          val _tmpExternalSystem: String?
          if (_stmt.isNull(_columnIndexOfExternalSystem)) {
            _tmpExternalSystem = null
          } else {
            _tmpExternalSystem = _stmt.getText(_columnIndexOfExternalSystem)
          }
          val _tmpExternalReferenceNumber: String?
          if (_stmt.isNull(_columnIndexOfExternalReferenceNumber)) {
            _tmpExternalReferenceNumber = null
          } else {
            _tmpExternalReferenceNumber = _stmt.getText(_columnIndexOfExternalReferenceNumber)
          }
          val _tmpExternalSubmittedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfExternalSubmittedAtMillis)) {
            _tmpExternalSubmittedAtMillis = null
          } else {
            _tmpExternalSubmittedAtMillis = _stmt.getLong(_columnIndexOfExternalSubmittedAtMillis)
          }
          val _tmpExternalLastCheckedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfExternalLastCheckedAtMillis)) {
            _tmpExternalLastCheckedAtMillis = null
          } else {
            _tmpExternalLastCheckedAtMillis = _stmt.getLong(_columnIndexOfExternalLastCheckedAtMillis)
          }
          val _tmpExternalReportedStatus: String?
          if (_stmt.isNull(_columnIndexOfExternalReportedStatus)) {
            _tmpExternalReportedStatus = null
          } else {
            _tmpExternalReportedStatus = _stmt.getText(_columnIndexOfExternalReportedStatus)
          }
          val _tmpSupportCount: Int
          _tmpSupportCount = _stmt.getLong(_columnIndexOfSupportCount).toInt()
          val _tmpCreatedAtMillis: Long
          _tmpCreatedAtMillis = _stmt.getLong(_columnIndexOfCreatedAtMillis)
          val _tmpUpdatedAtMillis: Long
          _tmpUpdatedAtMillis = _stmt.getLong(_columnIndexOfUpdatedAtMillis)
          val _tmpSyncState: String
          _tmpSyncState = _stmt.getText(_columnIndexOfSyncState)
          val _tmpLastSyncedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfLastSyncedAtMillis)) {
            _tmpLastSyncedAtMillis = null
          } else {
            _tmpLastSyncedAtMillis = _stmt.getLong(_columnIndexOfLastSyncedAtMillis)
          }
          val _tmpRemoteVersion: String?
          if (_stmt.isNull(_columnIndexOfRemoteVersion)) {
            _tmpRemoteVersion = null
          } else {
            _tmpRemoteVersion = _stmt.getText(_columnIndexOfRemoteVersion)
          }
          _result = IssueEntity(_tmpId,_tmpTitle,_tmpDescription,_tmpRequestedAction,_tmpCategory,_tmpStatus,_tmpPriority,_tmpLocationDescription,_tmpLatitude,_tmpLongitude,_tmpGeocodedAddress,_tmpNeighborhood,_tmpCouncilDistrict,_tmpCensusTract,_tmpPolicePrecinct,_tmpDepartmentId,_tmpReporterName,_tmpReporterEmail,_tmpReporterPhone,_tmpSubmittedByUserId,_tmpNotesSource,_tmpReviewState,_tmpReviewedByUserId,_tmpReviewedByDisplayName,_tmpReviewedAtMillis,_tmpRejectionReason,_tmpEditedByUserId,_tmpEditedByDisplayName,_tmpEditedAtMillis,_tmpEditRevision,_tmpEditedFields,_tmpResolution,_tmpExternalSystem,_tmpExternalReferenceNumber,_tmpExternalSubmittedAtMillis,_tmpExternalLastCheckedAtMillis,_tmpExternalReportedStatus,_tmpSupportCount,_tmpCreatedAtMillis,_tmpUpdatedAtMillis,_tmpSyncState,_tmpLastSyncedAtMillis,_tmpRemoteVersion)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun syncedIds(): List<String> {
    val _sql: String = "SELECT id FROM issues WHERE sync_state = 'synced'"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: MutableList<String> = mutableListOf()
        while (_stmt.step()) {
          val _item: String
          _item = _stmt.getText(0)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun count(): Int {
    val _sql: String = "SELECT COUNT(*) FROM issues"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Int
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp
        } else {
          _result = 0
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun pendingSync(): List<IssueEntity> {
    val _sql: String = "SELECT * FROM issues WHERE sync_state IN ('pending_upload', 'pending_delete', 'failed')"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfTitle: Int = getColumnIndexOrThrow(_stmt, "title")
        val _columnIndexOfDescription: Int = getColumnIndexOrThrow(_stmt, "description")
        val _columnIndexOfRequestedAction: Int = getColumnIndexOrThrow(_stmt, "requested_action")
        val _columnIndexOfCategory: Int = getColumnIndexOrThrow(_stmt, "category")
        val _columnIndexOfStatus: Int = getColumnIndexOrThrow(_stmt, "status")
        val _columnIndexOfPriority: Int = getColumnIndexOrThrow(_stmt, "priority")
        val _columnIndexOfLocationDescription: Int = getColumnIndexOrThrow(_stmt, "location_description")
        val _columnIndexOfLatitude: Int = getColumnIndexOrThrow(_stmt, "latitude")
        val _columnIndexOfLongitude: Int = getColumnIndexOrThrow(_stmt, "longitude")
        val _columnIndexOfGeocodedAddress: Int = getColumnIndexOrThrow(_stmt, "geocoded_address")
        val _columnIndexOfNeighborhood: Int = getColumnIndexOrThrow(_stmt, "neighborhood")
        val _columnIndexOfCouncilDistrict: Int = getColumnIndexOrThrow(_stmt, "council_district")
        val _columnIndexOfCensusTract: Int = getColumnIndexOrThrow(_stmt, "census_tract")
        val _columnIndexOfPolicePrecinct: Int = getColumnIndexOrThrow(_stmt, "police_precinct")
        val _columnIndexOfDepartmentId: Int = getColumnIndexOrThrow(_stmt, "department_id")
        val _columnIndexOfReporterName: Int = getColumnIndexOrThrow(_stmt, "reporter_name")
        val _columnIndexOfReporterEmail: Int = getColumnIndexOrThrow(_stmt, "reporter_email")
        val _columnIndexOfReporterPhone: Int = getColumnIndexOrThrow(_stmt, "reporter_phone")
        val _columnIndexOfSubmittedByUserId: Int = getColumnIndexOrThrow(_stmt, "submitted_by_user_id")
        val _columnIndexOfNotesSource: Int = getColumnIndexOrThrow(_stmt, "notes_source")
        val _columnIndexOfReviewState: Int = getColumnIndexOrThrow(_stmt, "review_state")
        val _columnIndexOfReviewedByUserId: Int = getColumnIndexOrThrow(_stmt, "reviewed_by_user_id")
        val _columnIndexOfReviewedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "reviewed_by_display_name")
        val _columnIndexOfReviewedAtMillis: Int = getColumnIndexOrThrow(_stmt, "reviewed_at")
        val _columnIndexOfRejectionReason: Int = getColumnIndexOrThrow(_stmt, "rejection_reason")
        val _columnIndexOfEditedByUserId: Int = getColumnIndexOrThrow(_stmt, "edited_by_user_id")
        val _columnIndexOfEditedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "edited_by_display_name")
        val _columnIndexOfEditedAtMillis: Int = getColumnIndexOrThrow(_stmt, "edited_at")
        val _columnIndexOfEditRevision: Int = getColumnIndexOrThrow(_stmt, "edit_revision")
        val _columnIndexOfEditedFields: Int = getColumnIndexOrThrow(_stmt, "edited_fields")
        val _columnIndexOfResolution: Int = getColumnIndexOrThrow(_stmt, "resolution")
        val _columnIndexOfExternalSystem: Int = getColumnIndexOrThrow(_stmt, "external_system")
        val _columnIndexOfExternalReferenceNumber: Int = getColumnIndexOrThrow(_stmt, "external_reference_number")
        val _columnIndexOfExternalSubmittedAtMillis: Int = getColumnIndexOrThrow(_stmt, "external_submitted_at")
        val _columnIndexOfExternalLastCheckedAtMillis: Int = getColumnIndexOrThrow(_stmt, "external_last_checked_at")
        val _columnIndexOfExternalReportedStatus: Int = getColumnIndexOrThrow(_stmt, "external_reported_status")
        val _columnIndexOfSupportCount: Int = getColumnIndexOrThrow(_stmt, "support_count")
        val _columnIndexOfCreatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "created_at")
        val _columnIndexOfUpdatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "updated_at")
        val _columnIndexOfSyncState: Int = getColumnIndexOrThrow(_stmt, "sync_state")
        val _columnIndexOfLastSyncedAtMillis: Int = getColumnIndexOrThrow(_stmt, "last_synced_at")
        val _columnIndexOfRemoteVersion: Int = getColumnIndexOrThrow(_stmt, "remote_version")
        val _result: MutableList<IssueEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: IssueEntity
          val _tmpId: String
          _tmpId = _stmt.getText(_columnIndexOfId)
          val _tmpTitle: String
          _tmpTitle = _stmt.getText(_columnIndexOfTitle)
          val _tmpDescription: String
          _tmpDescription = _stmt.getText(_columnIndexOfDescription)
          val _tmpRequestedAction: String
          _tmpRequestedAction = _stmt.getText(_columnIndexOfRequestedAction)
          val _tmpCategory: String
          _tmpCategory = _stmt.getText(_columnIndexOfCategory)
          val _tmpStatus: String
          _tmpStatus = _stmt.getText(_columnIndexOfStatus)
          val _tmpPriority: String
          _tmpPriority = _stmt.getText(_columnIndexOfPriority)
          val _tmpLocationDescription: String
          _tmpLocationDescription = _stmt.getText(_columnIndexOfLocationDescription)
          val _tmpLatitude: Double?
          if (_stmt.isNull(_columnIndexOfLatitude)) {
            _tmpLatitude = null
          } else {
            _tmpLatitude = _stmt.getDouble(_columnIndexOfLatitude)
          }
          val _tmpLongitude: Double?
          if (_stmt.isNull(_columnIndexOfLongitude)) {
            _tmpLongitude = null
          } else {
            _tmpLongitude = _stmt.getDouble(_columnIndexOfLongitude)
          }
          val _tmpGeocodedAddress: String?
          if (_stmt.isNull(_columnIndexOfGeocodedAddress)) {
            _tmpGeocodedAddress = null
          } else {
            _tmpGeocodedAddress = _stmt.getText(_columnIndexOfGeocodedAddress)
          }
          val _tmpNeighborhood: String?
          if (_stmt.isNull(_columnIndexOfNeighborhood)) {
            _tmpNeighborhood = null
          } else {
            _tmpNeighborhood = _stmt.getText(_columnIndexOfNeighborhood)
          }
          val _tmpCouncilDistrict: String?
          if (_stmt.isNull(_columnIndexOfCouncilDistrict)) {
            _tmpCouncilDistrict = null
          } else {
            _tmpCouncilDistrict = _stmt.getText(_columnIndexOfCouncilDistrict)
          }
          val _tmpCensusTract: String?
          if (_stmt.isNull(_columnIndexOfCensusTract)) {
            _tmpCensusTract = null
          } else {
            _tmpCensusTract = _stmt.getText(_columnIndexOfCensusTract)
          }
          val _tmpPolicePrecinct: String?
          if (_stmt.isNull(_columnIndexOfPolicePrecinct)) {
            _tmpPolicePrecinct = null
          } else {
            _tmpPolicePrecinct = _stmt.getText(_columnIndexOfPolicePrecinct)
          }
          val _tmpDepartmentId: String?
          if (_stmt.isNull(_columnIndexOfDepartmentId)) {
            _tmpDepartmentId = null
          } else {
            _tmpDepartmentId = _stmt.getText(_columnIndexOfDepartmentId)
          }
          val _tmpReporterName: String?
          if (_stmt.isNull(_columnIndexOfReporterName)) {
            _tmpReporterName = null
          } else {
            _tmpReporterName = _stmt.getText(_columnIndexOfReporterName)
          }
          val _tmpReporterEmail: String?
          if (_stmt.isNull(_columnIndexOfReporterEmail)) {
            _tmpReporterEmail = null
          } else {
            _tmpReporterEmail = _stmt.getText(_columnIndexOfReporterEmail)
          }
          val _tmpReporterPhone: String?
          if (_stmt.isNull(_columnIndexOfReporterPhone)) {
            _tmpReporterPhone = null
          } else {
            _tmpReporterPhone = _stmt.getText(_columnIndexOfReporterPhone)
          }
          val _tmpSubmittedByUserId: String?
          if (_stmt.isNull(_columnIndexOfSubmittedByUserId)) {
            _tmpSubmittedByUserId = null
          } else {
            _tmpSubmittedByUserId = _stmt.getText(_columnIndexOfSubmittedByUserId)
          }
          val _tmpNotesSource: String
          _tmpNotesSource = _stmt.getText(_columnIndexOfNotesSource)
          val _tmpReviewState: String
          _tmpReviewState = _stmt.getText(_columnIndexOfReviewState)
          val _tmpReviewedByUserId: String?
          if (_stmt.isNull(_columnIndexOfReviewedByUserId)) {
            _tmpReviewedByUserId = null
          } else {
            _tmpReviewedByUserId = _stmt.getText(_columnIndexOfReviewedByUserId)
          }
          val _tmpReviewedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfReviewedByDisplayName)) {
            _tmpReviewedByDisplayName = null
          } else {
            _tmpReviewedByDisplayName = _stmt.getText(_columnIndexOfReviewedByDisplayName)
          }
          val _tmpReviewedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfReviewedAtMillis)) {
            _tmpReviewedAtMillis = null
          } else {
            _tmpReviewedAtMillis = _stmt.getLong(_columnIndexOfReviewedAtMillis)
          }
          val _tmpRejectionReason: String?
          if (_stmt.isNull(_columnIndexOfRejectionReason)) {
            _tmpRejectionReason = null
          } else {
            _tmpRejectionReason = _stmt.getText(_columnIndexOfRejectionReason)
          }
          val _tmpEditedByUserId: String?
          if (_stmt.isNull(_columnIndexOfEditedByUserId)) {
            _tmpEditedByUserId = null
          } else {
            _tmpEditedByUserId = _stmt.getText(_columnIndexOfEditedByUserId)
          }
          val _tmpEditedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfEditedByDisplayName)) {
            _tmpEditedByDisplayName = null
          } else {
            _tmpEditedByDisplayName = _stmt.getText(_columnIndexOfEditedByDisplayName)
          }
          val _tmpEditedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfEditedAtMillis)) {
            _tmpEditedAtMillis = null
          } else {
            _tmpEditedAtMillis = _stmt.getLong(_columnIndexOfEditedAtMillis)
          }
          val _tmpEditRevision: Int?
          if (_stmt.isNull(_columnIndexOfEditRevision)) {
            _tmpEditRevision = null
          } else {
            _tmpEditRevision = _stmt.getLong(_columnIndexOfEditRevision).toInt()
          }
          val _tmpEditedFields: String?
          if (_stmt.isNull(_columnIndexOfEditedFields)) {
            _tmpEditedFields = null
          } else {
            _tmpEditedFields = _stmt.getText(_columnIndexOfEditedFields)
          }
          val _tmpResolution: String?
          if (_stmt.isNull(_columnIndexOfResolution)) {
            _tmpResolution = null
          } else {
            _tmpResolution = _stmt.getText(_columnIndexOfResolution)
          }
          val _tmpExternalSystem: String?
          if (_stmt.isNull(_columnIndexOfExternalSystem)) {
            _tmpExternalSystem = null
          } else {
            _tmpExternalSystem = _stmt.getText(_columnIndexOfExternalSystem)
          }
          val _tmpExternalReferenceNumber: String?
          if (_stmt.isNull(_columnIndexOfExternalReferenceNumber)) {
            _tmpExternalReferenceNumber = null
          } else {
            _tmpExternalReferenceNumber = _stmt.getText(_columnIndexOfExternalReferenceNumber)
          }
          val _tmpExternalSubmittedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfExternalSubmittedAtMillis)) {
            _tmpExternalSubmittedAtMillis = null
          } else {
            _tmpExternalSubmittedAtMillis = _stmt.getLong(_columnIndexOfExternalSubmittedAtMillis)
          }
          val _tmpExternalLastCheckedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfExternalLastCheckedAtMillis)) {
            _tmpExternalLastCheckedAtMillis = null
          } else {
            _tmpExternalLastCheckedAtMillis = _stmt.getLong(_columnIndexOfExternalLastCheckedAtMillis)
          }
          val _tmpExternalReportedStatus: String?
          if (_stmt.isNull(_columnIndexOfExternalReportedStatus)) {
            _tmpExternalReportedStatus = null
          } else {
            _tmpExternalReportedStatus = _stmt.getText(_columnIndexOfExternalReportedStatus)
          }
          val _tmpSupportCount: Int
          _tmpSupportCount = _stmt.getLong(_columnIndexOfSupportCount).toInt()
          val _tmpCreatedAtMillis: Long
          _tmpCreatedAtMillis = _stmt.getLong(_columnIndexOfCreatedAtMillis)
          val _tmpUpdatedAtMillis: Long
          _tmpUpdatedAtMillis = _stmt.getLong(_columnIndexOfUpdatedAtMillis)
          val _tmpSyncState: String
          _tmpSyncState = _stmt.getText(_columnIndexOfSyncState)
          val _tmpLastSyncedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfLastSyncedAtMillis)) {
            _tmpLastSyncedAtMillis = null
          } else {
            _tmpLastSyncedAtMillis = _stmt.getLong(_columnIndexOfLastSyncedAtMillis)
          }
          val _tmpRemoteVersion: String?
          if (_stmt.isNull(_columnIndexOfRemoteVersion)) {
            _tmpRemoteVersion = null
          } else {
            _tmpRemoteVersion = _stmt.getText(_columnIndexOfRemoteVersion)
          }
          _item = IssueEntity(_tmpId,_tmpTitle,_tmpDescription,_tmpRequestedAction,_tmpCategory,_tmpStatus,_tmpPriority,_tmpLocationDescription,_tmpLatitude,_tmpLongitude,_tmpGeocodedAddress,_tmpNeighborhood,_tmpCouncilDistrict,_tmpCensusTract,_tmpPolicePrecinct,_tmpDepartmentId,_tmpReporterName,_tmpReporterEmail,_tmpReporterPhone,_tmpSubmittedByUserId,_tmpNotesSource,_tmpReviewState,_tmpReviewedByUserId,_tmpReviewedByDisplayName,_tmpReviewedAtMillis,_tmpRejectionReason,_tmpEditedByUserId,_tmpEditedByDisplayName,_tmpEditedAtMillis,_tmpEditRevision,_tmpEditedFields,_tmpResolution,_tmpExternalSystem,_tmpExternalReferenceNumber,_tmpExternalSubmittedAtMillis,_tmpExternalLastCheckedAtMillis,_tmpExternalReportedStatus,_tmpSupportCount,_tmpCreatedAtMillis,_tmpUpdatedAtMillis,_tmpSyncState,_tmpLastSyncedAtMillis,_tmpRemoteVersion)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun observePhotos(issueId: String): Flow<List<IssuePhotoEntity>> {
    val _sql: String = "SELECT * FROM issue_photos WHERE issue_id = ? ORDER BY created_at ASC"
    return createFlow(__db, false, arrayOf("issue_photos")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, issueId)
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfIssueId: Int = getColumnIndexOrThrow(_stmt, "issue_id")
        val _columnIndexOfBytes: Int = getColumnIndexOrThrow(_stmt, "bytes")
        val _columnIndexOfRemoteUrl: Int = getColumnIndexOrThrow(_stmt, "remote_url")
        val _columnIndexOfCaption: Int = getColumnIndexOrThrow(_stmt, "caption")
        val _columnIndexOfCreatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "created_at")
        val _columnIndexOfSyncState: Int = getColumnIndexOrThrow(_stmt, "sync_state")
        val _columnIndexOfLastSyncedAtMillis: Int = getColumnIndexOrThrow(_stmt, "last_synced_at")
        val _columnIndexOfRemoteVersion: Int = getColumnIndexOrThrow(_stmt, "remote_version")
        val _result: MutableList<IssuePhotoEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: IssuePhotoEntity
          val _tmpId: String
          _tmpId = _stmt.getText(_columnIndexOfId)
          val _tmpIssueId: String
          _tmpIssueId = _stmt.getText(_columnIndexOfIssueId)
          val _tmpBytes: ByteArray?
          if (_stmt.isNull(_columnIndexOfBytes)) {
            _tmpBytes = null
          } else {
            _tmpBytes = _stmt.getBlob(_columnIndexOfBytes)
          }
          val _tmpRemoteUrl: String?
          if (_stmt.isNull(_columnIndexOfRemoteUrl)) {
            _tmpRemoteUrl = null
          } else {
            _tmpRemoteUrl = _stmt.getText(_columnIndexOfRemoteUrl)
          }
          val _tmpCaption: String?
          if (_stmt.isNull(_columnIndexOfCaption)) {
            _tmpCaption = null
          } else {
            _tmpCaption = _stmt.getText(_columnIndexOfCaption)
          }
          val _tmpCreatedAtMillis: Long
          _tmpCreatedAtMillis = _stmt.getLong(_columnIndexOfCreatedAtMillis)
          val _tmpSyncState: String
          _tmpSyncState = _stmt.getText(_columnIndexOfSyncState)
          val _tmpLastSyncedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfLastSyncedAtMillis)) {
            _tmpLastSyncedAtMillis = null
          } else {
            _tmpLastSyncedAtMillis = _stmt.getLong(_columnIndexOfLastSyncedAtMillis)
          }
          val _tmpRemoteVersion: String?
          if (_stmt.isNull(_columnIndexOfRemoteVersion)) {
            _tmpRemoteVersion = null
          } else {
            _tmpRemoteVersion = _stmt.getText(_columnIndexOfRemoteVersion)
          }
          _item = IssuePhotoEntity(_tmpId,_tmpIssueId,_tmpBytes,_tmpRemoteUrl,_tmpCaption,_tmpCreatedAtMillis,_tmpSyncState,_tmpLastSyncedAtMillis,_tmpRemoteVersion)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun pendingPhotos(): List<IssuePhotoEntity> {
    val _sql: String = "SELECT * FROM issue_photos WHERE sync_state != 'synced' ORDER BY created_at ASC"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfIssueId: Int = getColumnIndexOrThrow(_stmt, "issue_id")
        val _columnIndexOfBytes: Int = getColumnIndexOrThrow(_stmt, "bytes")
        val _columnIndexOfRemoteUrl: Int = getColumnIndexOrThrow(_stmt, "remote_url")
        val _columnIndexOfCaption: Int = getColumnIndexOrThrow(_stmt, "caption")
        val _columnIndexOfCreatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "created_at")
        val _columnIndexOfSyncState: Int = getColumnIndexOrThrow(_stmt, "sync_state")
        val _columnIndexOfLastSyncedAtMillis: Int = getColumnIndexOrThrow(_stmt, "last_synced_at")
        val _columnIndexOfRemoteVersion: Int = getColumnIndexOrThrow(_stmt, "remote_version")
        val _result: MutableList<IssuePhotoEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: IssuePhotoEntity
          val _tmpId: String
          _tmpId = _stmt.getText(_columnIndexOfId)
          val _tmpIssueId: String
          _tmpIssueId = _stmt.getText(_columnIndexOfIssueId)
          val _tmpBytes: ByteArray?
          if (_stmt.isNull(_columnIndexOfBytes)) {
            _tmpBytes = null
          } else {
            _tmpBytes = _stmt.getBlob(_columnIndexOfBytes)
          }
          val _tmpRemoteUrl: String?
          if (_stmt.isNull(_columnIndexOfRemoteUrl)) {
            _tmpRemoteUrl = null
          } else {
            _tmpRemoteUrl = _stmt.getText(_columnIndexOfRemoteUrl)
          }
          val _tmpCaption: String?
          if (_stmt.isNull(_columnIndexOfCaption)) {
            _tmpCaption = null
          } else {
            _tmpCaption = _stmt.getText(_columnIndexOfCaption)
          }
          val _tmpCreatedAtMillis: Long
          _tmpCreatedAtMillis = _stmt.getLong(_columnIndexOfCreatedAtMillis)
          val _tmpSyncState: String
          _tmpSyncState = _stmt.getText(_columnIndexOfSyncState)
          val _tmpLastSyncedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfLastSyncedAtMillis)) {
            _tmpLastSyncedAtMillis = null
          } else {
            _tmpLastSyncedAtMillis = _stmt.getLong(_columnIndexOfLastSyncedAtMillis)
          }
          val _tmpRemoteVersion: String?
          if (_stmt.isNull(_columnIndexOfRemoteVersion)) {
            _tmpRemoteVersion = null
          } else {
            _tmpRemoteVersion = _stmt.getText(_columnIndexOfRemoteVersion)
          }
          _item = IssuePhotoEntity(_tmpId,_tmpIssueId,_tmpBytes,_tmpRemoteUrl,_tmpCaption,_tmpCreatedAtMillis,_tmpSyncState,_tmpLastSyncedAtMillis,_tmpRemoteVersion)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun observePendingPhotoCount(): Flow<Int> {
    val _sql: String = "SELECT COUNT(*) FROM issue_photos WHERE sync_state != 'synced'"
    return createFlow(__db, false, arrayOf("issue_photos")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Int
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp
        } else {
          _result = 0
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun observeHistory(issueId: String): Flow<List<IssueStatusChangeEntity>> {
    val _sql: String = "SELECT * FROM issue_status_changes WHERE issue_id = ? ORDER BY changed_at DESC"
    return createFlow(__db, false, arrayOf("issue_status_changes")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, issueId)
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfIssueId: Int = getColumnIndexOrThrow(_stmt, "issue_id")
        val _columnIndexOfFromStatus: Int = getColumnIndexOrThrow(_stmt, "from_status")
        val _columnIndexOfToStatus: Int = getColumnIndexOrThrow(_stmt, "to_status")
        val _columnIndexOfNote: Int = getColumnIndexOrThrow(_stmt, "note")
        val _columnIndexOfChangedByUserId: Int = getColumnIndexOrThrow(_stmt, "changed_by_user_id")
        val _columnIndexOfChangedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "changed_by_display_name")
        val _columnIndexOfChangedAtMillis: Int = getColumnIndexOrThrow(_stmt, "changed_at")
        val _columnIndexOfSyncState: Int = getColumnIndexOrThrow(_stmt, "sync_state")
        val _columnIndexOfLastSyncedAtMillis: Int = getColumnIndexOrThrow(_stmt, "last_synced_at")
        val _columnIndexOfRemoteVersion: Int = getColumnIndexOrThrow(_stmt, "remote_version")
        val _result: MutableList<IssueStatusChangeEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: IssueStatusChangeEntity
          val _tmpId: String
          _tmpId = _stmt.getText(_columnIndexOfId)
          val _tmpIssueId: String
          _tmpIssueId = _stmt.getText(_columnIndexOfIssueId)
          val _tmpFromStatus: String?
          if (_stmt.isNull(_columnIndexOfFromStatus)) {
            _tmpFromStatus = null
          } else {
            _tmpFromStatus = _stmt.getText(_columnIndexOfFromStatus)
          }
          val _tmpToStatus: String
          _tmpToStatus = _stmt.getText(_columnIndexOfToStatus)
          val _tmpNote: String?
          if (_stmt.isNull(_columnIndexOfNote)) {
            _tmpNote = null
          } else {
            _tmpNote = _stmt.getText(_columnIndexOfNote)
          }
          val _tmpChangedByUserId: String?
          if (_stmt.isNull(_columnIndexOfChangedByUserId)) {
            _tmpChangedByUserId = null
          } else {
            _tmpChangedByUserId = _stmt.getText(_columnIndexOfChangedByUserId)
          }
          val _tmpChangedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfChangedByDisplayName)) {
            _tmpChangedByDisplayName = null
          } else {
            _tmpChangedByDisplayName = _stmt.getText(_columnIndexOfChangedByDisplayName)
          }
          val _tmpChangedAtMillis: Long
          _tmpChangedAtMillis = _stmt.getLong(_columnIndexOfChangedAtMillis)
          val _tmpSyncState: String
          _tmpSyncState = _stmt.getText(_columnIndexOfSyncState)
          val _tmpLastSyncedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfLastSyncedAtMillis)) {
            _tmpLastSyncedAtMillis = null
          } else {
            _tmpLastSyncedAtMillis = _stmt.getLong(_columnIndexOfLastSyncedAtMillis)
          }
          val _tmpRemoteVersion: String?
          if (_stmt.isNull(_columnIndexOfRemoteVersion)) {
            _tmpRemoteVersion = null
          } else {
            _tmpRemoteVersion = _stmt.getText(_columnIndexOfRemoteVersion)
          }
          _item = IssueStatusChangeEntity(_tmpId,_tmpIssueId,_tmpFromStatus,_tmpToStatus,_tmpNote,_tmpChangedByUserId,_tmpChangedByDisplayName,_tmpChangedAtMillis,_tmpSyncState,_tmpLastSyncedAtMillis,_tmpRemoteVersion)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun pendingStatusChanges(): List<IssueStatusChangeEntity> {
    val _sql: String = "SELECT * FROM issue_status_changes WHERE sync_state != 'synced' ORDER BY changed_at ASC"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfIssueId: Int = getColumnIndexOrThrow(_stmt, "issue_id")
        val _columnIndexOfFromStatus: Int = getColumnIndexOrThrow(_stmt, "from_status")
        val _columnIndexOfToStatus: Int = getColumnIndexOrThrow(_stmt, "to_status")
        val _columnIndexOfNote: Int = getColumnIndexOrThrow(_stmt, "note")
        val _columnIndexOfChangedByUserId: Int = getColumnIndexOrThrow(_stmt, "changed_by_user_id")
        val _columnIndexOfChangedByDisplayName: Int = getColumnIndexOrThrow(_stmt, "changed_by_display_name")
        val _columnIndexOfChangedAtMillis: Int = getColumnIndexOrThrow(_stmt, "changed_at")
        val _columnIndexOfSyncState: Int = getColumnIndexOrThrow(_stmt, "sync_state")
        val _columnIndexOfLastSyncedAtMillis: Int = getColumnIndexOrThrow(_stmt, "last_synced_at")
        val _columnIndexOfRemoteVersion: Int = getColumnIndexOrThrow(_stmt, "remote_version")
        val _result: MutableList<IssueStatusChangeEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: IssueStatusChangeEntity
          val _tmpId: String
          _tmpId = _stmt.getText(_columnIndexOfId)
          val _tmpIssueId: String
          _tmpIssueId = _stmt.getText(_columnIndexOfIssueId)
          val _tmpFromStatus: String?
          if (_stmt.isNull(_columnIndexOfFromStatus)) {
            _tmpFromStatus = null
          } else {
            _tmpFromStatus = _stmt.getText(_columnIndexOfFromStatus)
          }
          val _tmpToStatus: String
          _tmpToStatus = _stmt.getText(_columnIndexOfToStatus)
          val _tmpNote: String?
          if (_stmt.isNull(_columnIndexOfNote)) {
            _tmpNote = null
          } else {
            _tmpNote = _stmt.getText(_columnIndexOfNote)
          }
          val _tmpChangedByUserId: String?
          if (_stmt.isNull(_columnIndexOfChangedByUserId)) {
            _tmpChangedByUserId = null
          } else {
            _tmpChangedByUserId = _stmt.getText(_columnIndexOfChangedByUserId)
          }
          val _tmpChangedByDisplayName: String?
          if (_stmt.isNull(_columnIndexOfChangedByDisplayName)) {
            _tmpChangedByDisplayName = null
          } else {
            _tmpChangedByDisplayName = _stmt.getText(_columnIndexOfChangedByDisplayName)
          }
          val _tmpChangedAtMillis: Long
          _tmpChangedAtMillis = _stmt.getLong(_columnIndexOfChangedAtMillis)
          val _tmpSyncState: String
          _tmpSyncState = _stmt.getText(_columnIndexOfSyncState)
          val _tmpLastSyncedAtMillis: Long?
          if (_stmt.isNull(_columnIndexOfLastSyncedAtMillis)) {
            _tmpLastSyncedAtMillis = null
          } else {
            _tmpLastSyncedAtMillis = _stmt.getLong(_columnIndexOfLastSyncedAtMillis)
          }
          val _tmpRemoteVersion: String?
          if (_stmt.isNull(_columnIndexOfRemoteVersion)) {
            _tmpRemoteVersion = null
          } else {
            _tmpRemoteVersion = _stmt.getText(_columnIndexOfRemoteVersion)
          }
          _item = IssueStatusChangeEntity(_tmpId,_tmpIssueId,_tmpFromStatus,_tmpToStatus,_tmpNote,_tmpChangedByUserId,_tmpChangedByDisplayName,_tmpChangedAtMillis,_tmpSyncState,_tmpLastSyncedAtMillis,_tmpRemoteVersion)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun observeSupportedIssueIds(userId: String): Flow<List<String>> {
    val _sql: String = "SELECT issue_id FROM issue_supports WHERE user_id = ?"
    return createFlow(__db, false, arrayOf("issue_supports")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, userId)
        val _result: MutableList<String> = mutableListOf()
        while (_stmt.step()) {
          val _item: String
          _item = _stmt.getText(0)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun pendingSupports(): List<IssueSupportEntity> {
    val _sql: String = "SELECT * FROM issue_supports WHERE sync_state != 'synced' ORDER BY created_at ASC"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfIssueId: Int = getColumnIndexOrThrow(_stmt, "issue_id")
        val _columnIndexOfUserId: Int = getColumnIndexOrThrow(_stmt, "user_id")
        val _columnIndexOfCreatedAtMillis: Int = getColumnIndexOrThrow(_stmt, "created_at")
        val _columnIndexOfSyncState: Int = getColumnIndexOrThrow(_stmt, "sync_state")
        val _result: MutableList<IssueSupportEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: IssueSupportEntity
          val _tmpIssueId: String
          _tmpIssueId = _stmt.getText(_columnIndexOfIssueId)
          val _tmpUserId: String
          _tmpUserId = _stmt.getText(_columnIndexOfUserId)
          val _tmpCreatedAtMillis: Long
          _tmpCreatedAtMillis = _stmt.getLong(_columnIndexOfCreatedAtMillis)
          val _tmpSyncState: String
          _tmpSyncState = _stmt.getText(_columnIndexOfSyncState)
          _item = IssueSupportEntity(_tmpIssueId,_tmpUserId,_tmpCreatedAtMillis,_tmpSyncState)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun observePendingSupportCount(): Flow<Int> {
    val _sql: String = "SELECT COUNT(*) FROM issue_supports WHERE sync_state != 'synced'"
    return createFlow(__db, false, arrayOf("issue_supports")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Int
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp
        } else {
          _result = 0
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun delete(id: String) {
    val _sql: String = "DELETE FROM issues WHERE id = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, id)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun markSynced(
    id: String,
    syncedAtMillis: Long,
    remoteVersion: String?,
  ) {
    val _sql: String = """
        |
        |        UPDATE issues
        |        SET sync_state = 'synced', last_synced_at = ?, remote_version = ?
        |        WHERE id = ?
        |        
        """.trimMargin()
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, syncedAtMillis)
        _argIndex = 2
        if (remoteVersion == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, remoteVersion)
        }
        _argIndex = 3
        _stmt.bindText(_argIndex, id)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun markSyncState(id: String, state: String) {
    val _sql: String = "UPDATE issues SET sync_state = ? WHERE id = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, state)
        _argIndex = 2
        _stmt.bindText(_argIndex, id)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deletePhoto(id: String) {
    val _sql: String = "DELETE FROM issue_photos WHERE id = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, id)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun markPhotoSynced(
    id: String,
    remoteUrl: String,
    syncedAtMillis: Long,
  ) {
    val _sql: String = """
        |
        |        UPDATE issue_photos
        |        SET sync_state = 'synced',
        |            remote_url = ?,
        |            last_synced_at = ?
        |        WHERE id = ?
        |        
        """.trimMargin()
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, remoteUrl)
        _argIndex = 2
        _stmt.bindLong(_argIndex, syncedAtMillis)
        _argIndex = 3
        _stmt.bindText(_argIndex, id)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun mergeRemotePhoto(
    id: String,
    issueId: String,
    remoteUrl: String,
    caption: String?,
    createdAtMillis: Long,
    syncedAtMillis: Long?,
  ) {
    val _sql: String = """
        |
        |        INSERT INTO issue_photos
        |            (id, issue_id, bytes, remote_url, caption, created_at, sync_state, last_synced_at, remote_version)
        |        SELECT ?, ?, NULL, ?, ?, ?, 'synced', ?, NULL
        |        WHERE EXISTS (SELECT 1 FROM issues WHERE id = ?)
        |        ON CONFLICT(id) DO UPDATE SET
        |            remote_url = excluded.remote_url,
        |            caption = excluded.caption,
        |            sync_state = 'synced',
        |            last_synced_at = excluded.last_synced_at
        |        
        """.trimMargin()
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, id)
        _argIndex = 2
        _stmt.bindText(_argIndex, issueId)
        _argIndex = 3
        _stmt.bindText(_argIndex, remoteUrl)
        _argIndex = 4
        if (caption == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, caption)
        }
        _argIndex = 5
        _stmt.bindLong(_argIndex, createdAtMillis)
        _argIndex = 6
        if (syncedAtMillis == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, syncedAtMillis)
        }
        _argIndex = 7
        _stmt.bindText(_argIndex, issueId)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun mergeRemoteStatusChange(
    id: String,
    issueId: String,
    fromStatus: String?,
    toStatus: String,
    note: String?,
    changedByUserId: String?,
    changedByDisplayName: String?,
    changedAtMillis: Long,
  ) {
    val _sql: String = """
        |
        |        INSERT INTO issue_status_changes
        |            (id, issue_id, from_status, to_status, note, changed_by_user_id, changed_by_display_name,
        |             changed_at, sync_state, last_synced_at, remote_version)
        |        SELECT ?, ?, ?, ?, ?, ?, ?,
        |               ?, 'synced', NULL, NULL
        |        WHERE EXISTS (SELECT 1 FROM issues WHERE id = ?)
        |        ON CONFLICT(id) DO UPDATE SET sync_state = 'synced'
        |        
        """.trimMargin()
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, id)
        _argIndex = 2
        _stmt.bindText(_argIndex, issueId)
        _argIndex = 3
        if (fromStatus == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, fromStatus)
        }
        _argIndex = 4
        _stmt.bindText(_argIndex, toStatus)
        _argIndex = 5
        if (note == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, note)
        }
        _argIndex = 6
        if (changedByUserId == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, changedByUserId)
        }
        _argIndex = 7
        if (changedByDisplayName == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindText(_argIndex, changedByDisplayName)
        }
        _argIndex = 8
        _stmt.bindLong(_argIndex, changedAtMillis)
        _argIndex = 9
        _stmt.bindText(_argIndex, issueId)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun incrementSupportCount(issueId: String) {
    val _sql: String = "UPDATE issues SET support_count = support_count + 1 WHERE id = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, issueId)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun markSupportSynced(issueId: String, userId: String) {
    val _sql: String = "UPDATE issue_supports SET sync_state = 'synced' WHERE issue_id = ? AND user_id = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, issueId)
        _argIndex = 2
        _stmt.bindText(_argIndex, userId)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
